import { createIcon } from "@chakra-ui/react";

const av3CRV = createIcon({
  displayName: "av3CRV",
  viewBox: "-60 -50 540 540",
  path: (
    <g>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h414.7v417.8H0z" />
        </clipPath>
      </defs>
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m176.4 253.4-31.6 7-4-14.8 33.7-6.1 1.9 13.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m144.8 260.4-27.6 9.3-5.9-15.4 29.5-8.7 4 14.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0028ff"
              d="m174.4 239.5-33.6 6.1-3.5-17.3 35.4-5.2 1.7 16.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0018ff"
              d="m140.8 245.6-29.5 8.7-5.4-18 31.4-8 3.5 17.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000f1"
              d="m178.5 264.7-29.5 7.7-4.3-12 31.7-7 2.1 11.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000da"
              d="m149 272.4-25.4 9.8-6.4-12.5 27.6-9.3 4.2 12z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0058ff"
              d="m172.7 223.1-35.4 5.2-3.1-19.3 37-4.2 1.5 18.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0048ff"
              d="m137.3 228.3-31.4 8-4.6-20.2 32.9-7.1 3.1 19.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0014ff"
              d="m211 248.9-34.6 4.5-1.9-13.9 36.4-3.7.1 13.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000da"
              d="m180.8 273-27.4 8.2-4.4-8.8 29.5-7.7 2.3 8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000e8"
              d="m117.2 269.7-22.5 11.6-8-15.9 24.6-11.1 5.9 15.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c4"
              d="m153.4 281.2-23.1 10.3-6.7-9.3 25.4-9.8 4.4 8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#003cff"
              d="m210.9 235.8-36.4 3.7-1.8-16.4 38.1-2.6.1 15.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0008ff"
              d="m111.3 254.3-24.5 11.1-7.2-18.6 26.3-10.5 5.4 18z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m211.2 259.3-32.7 5.4-2.1-11.3 34.6-4.5.2 10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c8"
              d="m123.6 282.2-20.4 11.9-8.5-12.8 22.5-11.6 6.4 12.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0090ff"
              d="m171.2 204.8-37 4.2-2.5-20.9L170 185l1.2 19.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0084ff"
              d="m134.2 209-32.9 7.1-3.8-21.9 34.2-6.1 2.5 20.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m210.8 220.5-38.1 2.6-1.5-18.3 39.5-1.4.1 17.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#003cff"
              d="m105.9 236.3-26.3 10.5-6.2-20.8 27.9-9.9 4.6 20.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000f6"
              d="m211.4 267-30.6 6-2.3-8.3 32.7-5.4.2 7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000d1"
              d="m183 278.1-25.1 8.6-4.5-5.5 27.4-8.2 2.2 5.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ad"
              d="m130.3 291.5-18.2 12.1-8.9-9.5 20.4-11.9 6.7 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b"
              d="m157.9 286.7-20.8 10.5-6.8-5.7 23.1-10.3 4.5 5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m210.7 203.4-39.5 1.4L170 185l40.7-.2v18.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0078ff"
              d="M101.3 216.1 73.4 226l-5.1-22.6 29.2-9.2 3.8 21.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ed"
              d="m211.6 271.6-28.6 6.5-2.2-5.1 30.6-6 .2 4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0cf" d="m170 185-38.3 3.1-1.9-22 39.3-2 .9 20.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#002cff"
              d="m247 246.5-36 2.4-.1-13.1 37.6-1.3-1.5 12z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m131.7 188.1-34.3 6.1-2.9-23 35.3-5.1 1.9 22z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0014ff"
              d="m245.4 256.1-34.2 3.2-.2-10.4 36-2.4-1.6 9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0050ff"
              d="m248.5 234.5-37.6 1.3-.1-15.2 39.1-.2-1.4 14.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000da"
              d="m94.7 281.3-17.2 13.5-9.8-16.1 19-13.3 8 15.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m86.7 265.4-19 13.3-8.8-19 20.7-12.9 7.1 18.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000a4"
              d="m137.1 297.2-16 12.2-9-5.8 18.2-12.1 6.8 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000b6"
              d="m103.2 294.1-15.3 13.7-10.4-13 17.2-13.5 8.5 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000d6"
              d="m185.3 279.9-22.9 8.8-4.5-2 25.1-8.6 2.3 1.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0004ff"
              d="m243.8 263-32.4 4-.2-7.7 34.2-3.2-1.6 6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0078ff"
              d="m249.9 220.4-39.1.1-.1-17.1 40.4 1.1-1.2 15.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000bf"
              d="m162.4 288.7-18.5 10.6-6.8-2.1 20.8-10.5 4.5 2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00d8ff" d="m210.7 184.8-40.7.2-.9-20.9 41.6 1v19.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0034ff"
              d="m79.6 246.8-20.7 12.9-7.7-21.2L73.4 226l6.2 20.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000f1"
              d="m211.8 273.1-26.5 6.8-2.3-1.7 28.6-6.6.2 1.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009f"
              d="m112.1 303.6-13.2 13.7-11-9.5 15.3-13.7 8.9 9.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00bcff"
              d="m97.4 194.2-29.1 9.2-3.9-23.8 30.1-8.4 2.9 23z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00f" d="m242.2 267-30.6 4.6-.2-4.6 32.4-4-1.6 4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#23ffd4"
              d="m169.1 164.1-39.3 2-1.2-22.6 39.9-.9.6 21.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="m251.1 204.5-40.4-1.1v-18.6l41.5 2.4-1.1 17.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m129.8 166.1-35.2 5.1-1.9-23.6 35.9-4.1 1.2 22.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ad"
              d="m143.9 299.3-13.8 12.2-9-2.1 16-12.2 6.8 2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0070ff"
              d="m73.4 226-22.2 12.5-6.3-23.2 23.4-11.9 5.1 22.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000e8"
              d="m187.5 278.3-20.8 8.9-4.3 1.5 22.9-8.8 2.2-1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000096"
              d="M121.1 309.4 110 323l-11.1-5.7 13.2-13.7 9 5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#26ffd1"
              d="m210.7 165.1-41.6-1-.6-21.5 42.3 2.3-.1 20.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m240.6 268.1-28.8 4.9-.2-1.4 30.6-4.6-1.6 1.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#04f" d="m282.6 246.2-35.6.3 1.5-12 37 .9-2.9 10.8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#002cff"
              d="m279.5 254.8-34.1 1.3 1.6-9.6 35.6-.3-3.1 8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000d1"
              d="m166.8 287.2-16.4 10.5-6.5 1.6 18.5-10.6 4.4-1.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m252.2 187.2-41.5-2.4v-19.7l42.3 3.8-.8 18.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00f" d="m212 271.3-24.5 7-2.2 1.6 26.5-6.8.2-1.8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0064ff"
              d="m285.5 235.4-37-.9 1.4-14.1 38.2 2.1-2.6 12.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#19ffde"
              d="m94.6 171.2-30.2 8.4-2.6-24.5 30.9-7.5 1.9 23.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#001cff"
              d="m276.4 260.9-32.6 2.1 1.6-6.9 34.1-1.3-3.1 6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000d1"
              d="m77.5 294.8-12 15-11.3-16.1 13.5-15 9.8 16.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000a8"
              d="m87.9 307.8-10.2 14.9-12.2-12.9 12-15 10.4 13z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m168.5 142.6-39.9.9-.5-22.7 40.2.3.2 21.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#008cff"
              d="m288.1 222.5-38.2-2.1 1.2-15.9 39.3 3.4-2.3 14.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m67.7 278.7-13.6 15-10.2-19.1 15-14.9 8.8 19z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m68.3 203.4-23.4 12-4.8-24.5 24.3-11.3 3.9 23.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m128.6 143.5-35.9 4.1-.9-23.6 36.3-3.2.5 22.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0018ff"
              d="m273.2 264.3-31 2.7 1.6-4 32.6-2.1-3.2 3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000bf"
              d="m150.4 297.7-11.5 12-8.8 1.8 13.8-12.2 6.5-1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00009b" d="m130.1 311.5-9 13.4-11-1.9 11-13.5 9 2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000092"
              d="M98.9 317.3 90.5 332l-12.7-9.3 10.1-14.9 11 9.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#000cff" d="m239 266.2-27 5.1-.2 1.8 28.8-5-1.6-1.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#002cff"
              d="m58.9 259.7-15 14.9-9-21.4 16.3-14.7 7.7 21.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5dff9a"
              d="m210.8 144.9-42.3-2.3-.2-21.5 42.6 3.6-.1 20.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#2cffca"
              d="m253 168.9-42.3-3.8.1-20.2 42.8 5.1-.6 18.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m290.4 207.9-39.3-3.4 1.1-17.3 40.2 4.7-2 16z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m189.6 273.3-18.7 8.7-4.1 5.2 20.7-8.9 2.1-5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000cff"
              d="m212.3 266.4-22.7 6.9-2.1 5 24.5-7 .3-4.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0018ff" d="m270 265-29.4 3.1 1.6-1.1 31-2.7-3.2.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000f1"
              d="m170.9 282-14.3 10.3-6.2 5.4 16.4-10.5 4.1-5.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m92.7 147.6-30.9 7.5-1.1-24.5 31.1-6.6.9 23.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000089"
              d="m110.1 323-6.6 14.5-13-5.5 8.4-14.7 11.2 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#006cff"
              d="m51.2 238.5-16.3 14.7-7.3-23.4 17.3-14.5 6.3 23.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m64.4 179.6-24.3 11.3-3.2-25.1 24.9-10.7 2.6 24.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#06ecf1"
              d="m292.4 191.9-40.2-4.7.8-18.3 40.9 6.1-1.5 16.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m168.3 121.1-40.2-.3.2-22 40.1 1.4-.1 20.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0024ff"
              d="m237.6 261.4-25.3 5-.3 4.9 27-5.1-1.4-4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ad"
              d="m138.9 309.7-7 13.1-10.8 2.1 9-13.4 8.8-1.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#04f"
              d="m311.6 255.3-32.1-.5 3.1-8.6 33.2 1.5-4.2 7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#005cff"
              d="m315.8 247.7-33.2-1.5 2.9-10.8 34.3 2.6-4 9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5dff9a"
              d="m253.6 150-42.8-5.1.1-20.2 43.1 6.4-.4 18.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="M128.1 120.8 91.8 124l.3-23.1 36.2-2.1-.2 22z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0028ff"
              d="m267 262.9-28 3.3 1.6 1.9L270 265l-3-2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000df"
              d="m156.6 292.3-9.5 11.7-8.2 5.7 11.5-12 6.2-5.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0038ff"
              d="m307.2 260.6-30.8.3 3.1-6.1 32.1.5-4.4 5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0078ff"
              d="m319.8 238-34.3-2.6 2.6-12.9 35.3 3.8-3.6 11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#90ff66"
              d="m210.9 124.7-42.6-3.6.1-20.9 42.6 4.7-.1 19.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00008d"
              d="m121.1 324.9-4.7 14.1-12.9-1.5 6.6-14.5 11 1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#001cff"
              d="m191.6 265-17 8.4-3.7 8.6 18.7-8.7 2-8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0034ff"
              d="m302.7 263.4-29.5.9 3.2-3.4 30.7-.3-4.4 2.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0030ff"
              d="m212.5 258.4-20.9 6.6-2 8.3 22.7-6.9.2-8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a0ff"
              d="m323.4 226.3-35.3-3.8 2.3-14.6 36.2 5.2-3.2 13.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#33ffc4"
              d="m293.9 175-40.9-6.1.6-18.9 41.4 7.5-1.1 17.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m44.9 215.3-17.3 14.5L22 205l18.1-14.1 4.8 24.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c8"
              d="m65.5 309.8-7 16-12.7-15.9 8.3-16.2 11.4 16.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000a4"
              d="m77.8 322.7-5.7 15.7-13.6-12.6 7-16 12.3 12.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0008ff"
              d="m174.6 273.4-12.3 10-5.7 8.9 14.3-10.3 3.7-8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m54.2 293.7-8.4 16.2L34.4 291l9.5-16.4 10.3 19.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m91.8 124-31.1 6.6.3-23.9 31.1-5.8-.3 23.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0034ff"
              d="M298.3 263.7 270 265l3.2-.7 29.5-.9-4.4.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#003cff"
              d="m264.2 258.1-26.6 3.3 1.4 4.8 28-3.3-2.8-4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m61.8 155.1-24.9 10.7-1.4-25.2 25.2-10 1.1 24.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000089"
              d="m90.5 332-4.2 15.3-14.2-8.9 5.7-15.7 12.7 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#04f" d="m236.4 253.6-23.9 4.8-.2 8 25.3-5-1.2-7.8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m326.6 213.1-36.2-5.2 2-16 36.9 6.6-2.7 14.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#90ff66" d="m254 131.1-43.1-6.4.1-19.8 43 7.7v18.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#caff2c"
              d="m168.4 100.2-40.1-1.4.9-21 39.8 2.5-.6 19.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000cd"
              d="m147.1 304-5 12.7-10.2 6.1 7-13.1 8.2-5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0028ff"
              d="M43.9 274.6 34.4 291l-10-21.4 10.5-16.4 9 21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ceff29"
              d="m128.3 98.8-36.2 2.1L93.4 79l35.8-1.2-.9 21z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c7ff30"
              d="m211 104.9-42.6-4.7.6-19.9 42.1 5.8-.1 18.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009f"
              d="m131.9 322.8-2.9 13.7-12.6 2.5 4.8-14.1 10.7-2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#60ff97"
              d="m295 157.5-41.4-7.5.4-18.9 41.6 8.8-.6 17.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0040ff"
              d="m294.2 261.4-27.2 1.5 3 2.1 28.3-1.3-4.1-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m162.3 283.3-7.6 11.3-7.6 9.4 9.5-11.7 5.7-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="navy"
              d="m103.5 337.5-2.7 14.8-14.5-5 4.2-15.3 13 5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="M40.1 190.9 22 205l-3.7-25.6 18.6-13.6 3.2 25.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0ff8e7"
              d="m329.3 198.5-36.9-6.6 1.5-16.9 37.5 8-2.1 15.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0058ff"
              d="m212.7 247.5-19.4 6.1-1.7 11.4 20.9-6.6.2-10.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0048ff"
              d="m193.3 253.6-15.3 7.9-3.4 11.9 17-8.4 1.7-11.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0058ff"
              d="m261.7 250.6-25.3 3 1.2 7.8 26.6-3.3-2.5-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m34.9 253.2-10.5 16.4-8.2-23.5 11.4-16.3 7.3 23.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0060ff"
              d="m339.6 257.3-28-2 4.2-7.6 28.9 3-5.1 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m334.3 261.8-27.1-1.2 4.4-5.3 28 2-5.3 4.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0074ff"
              d="m344.7 250.7-28.9-3 4-9.7 29.7 4-4.8 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#006cff"
              d="m235.3 243.2-22.6 4.3-.2 10.9 23.9-4.8-1.1-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0038ff"
              d="m178 261.5-10.7 9.4-5 12.4 12.3-9.9 3.4-11.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m290.2 256.5-26 1.6 2.8 4.8 27.1-1.5-3.9-4.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m254 112.6-43-7.7.1-18.8 42.8 8.8.1 17.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000084"
              d="m116.4 339-1.3 14.4-14.3-1 2.7-14.9 12.9 1.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="m60.7 130.6-25.2 10 .4-24.7 25.1-9.2-.3 23.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#004cff"
              d="m328.9 263.9-26.2-.5 4.5-2.8 27.1 1.2-5.4 2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="M92.1 100.9 61 106.7l1.7-22.8L93.4 79l-1.3 21.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0090ff"
              d="m349.5 242-29.7-4 3.6-11.7 30.5 5.3-4.4 10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#36ffc1"
              d="m331.4 183-37.5-8 1.1-17.5 37.8 9.4-1.4 16.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#8dff6a"
              d="m295.6 139.9-41.6-8.8v-18.5l41.6 10.1v17.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m169 80.3-39.8-2.5 1.6-19.3 39 3.4-.8 18.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m154.7 294.6-3.3 12.3-9.3 9.8 5-12.7 7.6-9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0050ff"
              d="m323.6 263.8-25.3-.1 4.4-.3 26.2.5-5.3-.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c4"
              d="m142.1 316.7-1.3 13.3-11.8 6.5 2.9-13.7 10.2-6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m353.9 231.6-30.5-5.3 3.2-13.2 31.2 6.5-3.9 12z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="M211.1 86.1 169 80.3l.8-18.4 41.5 6.8-.2 17.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0080ff"
              d="m259.5 240.7-24.2 2.5 1.1 10.4 25.3-3-2.2-9.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="M129.2 77.8 93.4 79l2.4-20.2 35-.3-1.6 19.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m36.9 165.8-18.6 13.6-1.7-25.7 18.9-13.1 1.4 25.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m27.6 229.8-11.4 16.3-6.2-24.9L22 205l5.6 24.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#002cff"
              d="m167.3 270.9-6 10.7-6.6 13 7.6-11.3 5-12.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0070ff"
              d="m286.7 249.3-25 1.3 2.5 7.5 26-1.6-3.5-7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009f"
              d="m72.1 338.4-1.2 15.2-14.2-12.4 1.8-15.4 13.6 12.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c8"
              d="m58.5 325.8-1.8 15.4-13.2-15.7 2.3-15.6 12.7 15.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#008cff"
              d="m213 233.9-18.2 5.5-1.5 14.2 19.4-6.1.3-13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#005cff"
              d="m318.6 261.3-24.5.1 4.2 2.3 25.3.1-5-2.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#007cff"
              d="m194.8 239.4-14 7.1-2.8 15 15.3-7.9 1.5-14.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m357.8 219.6-31.2-6.5 2.7-14.6 31.7 7.9-3.2 13.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000089"
              d="m86.3 347.3-.6 14.9-14.8-8.6 1.2-15.2 14.2 8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009b"
              d="m129 336.5.1 13.8-14 3.1 1.3-14.4 12.6-2.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#63ff94"
              d="m332.8 166.9-37.8-9.4.6-17.6 38 10.8-.8 16.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000fa"
              d="m45.8 309.9-2.3 15.6-11.9-18.8 2.8-15.7 11.4 18.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m234.4 230.3-21.4 3.6-.2 13.6 22.5-4.3-.9-12.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m253.9 94.9-42.8-8.8.2-17.4 42.1 9.9.5 16.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="M295.6 122.7 254 112.5l-.1-17.6 41.3 11.3.4 16.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0070ff"
              d="m180.8 246.5-9.3 8.8-4.2 15.6 10.7-9.4 2.8-15z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="navy" d="M100.8 352.4V367l-15.1-4.8.6-14.9 14.5 5.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#006cff"
              d="M313.8 256.5h-23.6l4 4.9 24.4-.1-4.8-4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d4ff23"
              d="M61 106.7 35.9 116 38 92.4l24.7-8.5-1.7 22.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#19ffde"
              d="m361 206.4-31.7-7.9 2.1-15.5 32 9.3-2.4 14.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m93.4 79-30.7 4.9 3.2-21 29.9-4.1L93.4 79z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0024ff"
              d="m34.4 291-2.8 15.7-10.4-21.3 3.2-15.8 10 21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0094ff"
              d="m283.7 239.9-24.2.8 2.2 9.9 25-1.3-3-9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="m257.7 228.5-23.3 1.8.9 12.9 24.2-2.5-1.8-12.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb200"
              d="m169.8 61.9-39-3.4 2.3-17.1 38 4.2-1.3 16.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#13fce4" d="m22 205-12 16.2-4.1-25.8 12.4-16L22 205z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000f1"
              d="m151.4 306.9.2 12.7-10.8 10.4 1.3-13.3 9.3-9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffbd00"
              d="m211.3 68.7-41.5-6.8 1.2-16.3 40.5 7.7-.2 15.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0020ff"
              d="m161.3 281.6-1.7 11.7-8.2 13.6 3.3-12.3 6.6-13z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#8dff6a" d="m333.6 150.6-38-10.7v-17.2l38 12v15.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#006cff"
              d="m355.9 264.1-21.6-2.3 5.3-4.5 22.2 3.1-5.9 3.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0078ff"
              d="m361.8 260.4-22.2-3.1 5.1-6.6 22.8 4-5.7 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="m35.5 140.6-18.9 13.1.5-25.2 18.8-12.6-.4 24.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m349.9 265.7-21-1.8 5.4-2.1 21.6 2.3-6 1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#008cff"
              d="m367.5 254.7-22.8-4 4.8-8.7 23.4 5.1-5.4 7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m130.8 58.5-35 .3 3.4-18 33.9.6-2.3 17.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m213.2 218-17.3 4.6-1.1 16.7 18.2-5.4.2-15.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000084"
              d="m115.1 353.4.6 14.4-14.9-.8v-14.6l14.3 1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b"
              d="m140.8 330 1.4 13.3-13.1 7-.1-13.8 11.8-6.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0084ff"
              d="m309.6 249.5-22.9-.2 3.5 7.2h23.6l-4.2-7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m171.5 255.3-4.6 10.1-5.6 16.3 6-10.8 4.2-15.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m363.4 192.3-32-9.3 1.4-16.1 32.3 10.7-1.7 14.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m233.8 215.3-20.6 2.7-.2 15.9 21.4-3.6-.6-15z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0064ff"
              d="m24.4 269.6-3.2 15.8-8.5-23.5 3.5-15.8 8.2 23.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m344.1 265.2-20.5-1.4 5.3.1 21 1.8-5.8-.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m195.9 222.6-12.9 6.3-2.2 17.6 14-7.1 1.1-16.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a4ff"
              d="m372.9 247.1-23.4-5.1 4.4-10.4 23.9 6.3-4.9 9.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ebff0c"
              d="m295.2 106.2-41.3-11.3-.5-16.3 40.8 12.3 1 15.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc800"
              d="m253.4 78.6-42.1-9.9.2-15.4L252.7 64l.7 14.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00bcff"
              d="m281.2 228.4-23.5.1 1.8 12.2 24.2-.8-2.5-11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0074ff"
              d="m338.4 262.5-19.8-1.2 5 2.5 20.5 1.4-5.7-2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m377.8 237.9-23.9-6.3 3.8-12 24.3 7.6-4.2 10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m256.4 214.4-22.6.9.6 15 23.3-1.8-1.3-14.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m183 228.9-8.2 8-3.3 18.4 9.3-8.8 2.2-17.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b7ff40"
              d="m333.6 134.7-38-12-.5-16.5 37.8 13.2.7 15.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00a4ff" d="m305.9 240.5-22.2-.6 3 9.4 22.9.2-3.7-9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#63ff94"
              d="m365.1 177.6-32.3-10.7.8-16.2 32.4 12-.9 14.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000096"
              d="m129.1 350.3 1.1 14.1-14.5 3.4-.6-14.4 14-3.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m18.3 179.4-12.4 16-1.9-26 12.6-15.7 1.7 25.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="gold" d="M62.7 83.9 38 92.4l4-21.7 23.9-7.8-3.2 21z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7a00"
              d="m171 45.6-37.9-4.2 3-14.5 36.5 4.9-1.6 13.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9c00"
              d="m95.8 58.8-29.9 4.1 4.6-18.7 28.7-3.4-3.4 18z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8900"
              d="m211.5 53.3-40.4-7.7 1.5-13.8 39.1 8.4-.2 13.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0084ff"
              d="m333.2 257.7-19.4-1.2 4.8 4.8 19.8 1.2-5.2-4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009f"
              d="m70.9 353.6 1.7 13.8-14.1-12.3-1.8-13.9 14.2 12.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m382 227.2-24.2-7.6 3.2-13.2 24.6 8.8-3.6 12z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c8"
              d="m56.7 341.2 1.8 13.9-13.2-15.7-1.8-13.9 13.2 15.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0018ff"
              d="m159.6 293.3 1.6 12.2-9.6 14.1-.2-12.7 8.2-13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="M16.2 246.1 12.7 262l-6.5-25 3.8-15.8 6.2 24.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000089"
              d="m85.7 362.2 1.7 13.9-14.8-8.7-1.7-13.8 14.8 8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#005cff"
              d="m166.9 265.4-.5 11.1-6.8 16.8 1.7-11.6 5.6-16.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m213.3 200.1-16.6 3.6-.8 18.9 17.3-4.6.1-17.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ed"
              d="m151.6 319.6 2.7 12.7-12.1 11-1.4-13.3 10.8-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="gold"
              d="m294.2 90.9-40.8-12.3-.7-14.6 40 13.2 1.5 13.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m233.4 198.5-20.1 1.6-.1 17.9 20.6-2.7-.4-16.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m35.9 115.9-18.8 12.6 2.5-24.2L38 92.4l-2.1 23.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000fa"
              d="m43.5 325.5 1.8 13.9-11.9-18.7-1.8-14 11.9 18.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m279.3 215.2-22.9-.8 1.3 14.1 23.5-.1-1.9-13.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6f00"
              d="m133.1 41.4-33.9-.6 4.4-15.1 32.5 1.2-3 14.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m252.7 64-41.2-10.7.2-13.1 40.1 11.4.9 12.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#13fce4"
              d="m196.7 203.7-12.2 5.3-1.5 19.9 12.9-6.3.8-18.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m328.4 251-18.8-1.5 4.2 7 19.3 1.2-4.7-6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a8ff"
              d="m174.8 236.9-3.6 9.4-4.3 19.1 4.6-10.1 3.3-18.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf"
              d="m302.8 229.7-21.6-1.3 2.5 11.5 22.2.6-3.1-10.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1fffd7"
              d="m385.6 215.2-24.6-8.8 2.4-14.1 24.9 10.1-2.7 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="navy" d="m100.7 367 1.7 13.9-15-4.8-1.7-13.9 15 4.8z" />
          </g>
          <g clipPath="url(#a)">
            <path fill="#8dff6a" d="m366 162.7-32.4-12v-16L366 148v14.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e1ff16"
              d="m332.9 119.4-37.7-13.2-1-15.3 37.3 14.2 1.4 14.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#23ffd4"
              d="m255.6 198.7-22.2-.2.4 16.8 22.6-.9-.8-15.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0024ff"
              d="m31.6 306.7 1.8 14L23 299.4l-1.8-14 10.4 21.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0084ff"
              d="m370.6 267.5-14.7-3.4 5.9-3.7 15 4.1-6.2 3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b"
              d="m142.2 343.3 1.7 13.8-13.7 7.3-1.1-14.1 13.1-7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0080ff"
              d="m364.3 268.5-14.4-2.8 6-1.6 14.7 3.4-6.3 1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0090ff"
              d="m376.8 264.5-15-4.1 5.7-5.7 15.4 4.9-6.1 4.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0084ff"
              d="m358.1 267.7-14-2.5 5.8.5 14.4 2.8-6.2-.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a0ff"
              d="m382.9 259.6-15.4-4.9 5.4-7.6 15.6 5.9-5.6 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m184.5 209-7.5 7.1-2.2 20.8 8.2-8 1.5-19.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#13fce4"
              d="M10 221.2 6.2 237l-4.3-25.8 4-15.8 4.1 25.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m324.3 242.5-18.4-2 3.7 9 18.8 1.5-4.1-8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6000"
              d="m211.7 40.2-39.1-8.4 1.8-10.9 37.6 8.9-.3 10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m388.3 202.4-24.9-10.1 1.7-14.7 25.1 11.4-1.9 13.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="M16.6 153.7 4 169.4l.5-25.7 12.6-15.2-.5 25.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000084"
              d="m115.7 367.8 1.7 13.9-15-.8-1.6-13.9 14.9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="m172.6 31.8-36.5-4.9 3.4-11.5 34.9 5.5-1.8 10.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffab00"
              d="m292.7 77.2-40-13.2-.9-12.4 39 13.9 1.9 11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#008cff"
              d="m352.1 264.8-13.7-2.3 5.7 2.7 14 2.5-6-2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#2cffca"
              d="m278.1 200.6-22.5-1.9.8 15.7 22.9.8-1.2-14.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m388.5 253-15.6-5.9 4.9-9.2 15.9 6.9-5.2 8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="M65.9 62.9 42 70.7l5.6-19.4 22.9-7.1-4.6 18.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6400"
              d="m99.2 40.8-28.7 3.4 5.8-15.9 27.3-2.6-4.4 15.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m300.6 217.4-21.3-2.2 1.9 13.2 21.6 1.3-2.2-12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m233.3 180.3-19.8.5-.2 19.3 20.1-1.6-.1-18.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#4dffaa"
              d="m213.5 180.8-16.3 2.3-.5 20.6 16.6-3.6.2-19.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b4ff43"
              d="m366 148-32.4-13.3-.7-15.3 32.2 14.4.9 14.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0058ff"
              d="m166.4 276.5 2.8 11.6-8 17.4-1.6-12.2 6.8-16.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6f00"
              d="m251.8 51.6-40.1-11.4.3-10.4 38.7 12 1.1 9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m21.2 285.4 1.8 14-8.5-23.3-1.8-14.2 8.5 23.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m331.5 105.1-37.3-14.2-1.5-13.7 36.7 15.1 2.1 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0014ff"
              d="m161.2 305.5 3.7 12.2-10.6 14.6-2.7-12.7 9.6-14.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a0ff"
              d="m171.2 246.3.6 10.4-5.4 19.8.5-11.1 4.3-19.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m346.6 260.1-13.5-2.3 5.3 4.7 13.7 2.3-5.5-4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m255.3 181.8-22-1.4.1 18.1 22.2.2-.3-16.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m393.7 244.8-15.9-6.9 4.2-10.7 16.1 8-4.4 9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3f00"
              d="m136.1 26.9-32.5-1.2 5.3-12 30.6 1.7-3.4 11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd300"
              d="m38 92.4-18.4 11.9L24.2 82 42 70.7l-4 21.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#49ffad"
              d="m197.2 183.1-11.9 4.3-.8 21.6 12.2-5.3.5-20.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m320.9 232.4-18.1-2.7 3.1 10.8 18.4 2-3.4-10.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#66ff90"
              d="m390.2 189-25.1-11.4.9-14.9 25.1 12.7-.9 13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#09f0ee"
              d="m177 216.1-2.8 8.6-3 21.6 3.6-9.4 2.2-20.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009b"
              d="m130.2 364.5 1.6 13.9-14.4 3.3-1.7-13.9 14.5-3.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000e8"
              d="m154.3 332.3 2.2 13.6-12.6 11.2-1.7-13.8 12.1-11z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m341.5 253.6-13.1-2.6 4.8 6.7 13.4 2.4-5.1-6.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m398.1 235.2-16.1-8 3.6-12 16.3 9.3-3.8 10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#33ffc4"
              d="m299.1 203.9-21-3.3 1.2 14.6 21.3 2.2-1.5-13.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m277.6 184.9-22.4-3.1.4 16.9 22.5 1.9-.5-15.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3b00"
              d="m212 29.8-37.6-8.9 2-7.7 35.8 9.3-.2 7.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000a8"
              d="m72.6 367.4 2.7 12.5-14-12.2-2.8-12.6 14.1 12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m365.1 133.8-32.2-14.4-1.4-14.3 31.9 15.5 1.7 13.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8600"
              d="m290.8 65.5-39-13.9-1.1-9.8 37.8 14.4 2.3 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000cd"
              d="m58.5 355.1 2.8 12.6-13.1-15.6-2.9-12.7 13.2 15.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#53ffa4" d="m5.9 195.4-4 15.8L0 185l4-15.6 1.9 26z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#46ffb1"
              d="m185.3 187.4-7.1 6.1-1.2 22.6 7.5-7.1.8-21.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ff2900" d="m174.4 20.9-34.9-5.5 4-8 32.9 5.8-2 7.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m12.7 261.9 1.8 14.2L8 251.2 6.2 237l6.5 24.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m233.5 161.3-19.9-.9-.1 20.4 19.8-.4.2-19.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000092"
              d="m87.4 376.1 2.5 12.4-14.6-8.6-2.7-12.5 14.8 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m329.4 92.3-36.7-15.1-1.9-11.7 35.9 15.8 2.7 11z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m213.6 160.4-16.4 1.1v21.6l16.3-2.3.1-20.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m318.4 220.9-17.8-3.5 2.2 12.4 18.1 2.6-2.5-11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="m250.7 41.8-38.7-12 .2-7.3 37.1 12.2 1.4 7.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#8aff6d"
              d="M391.1 175.4 366 162.7V148l25.1 13.9v13.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="M17.1 128.5 4.5 143.7l2.9-24.5 12.2-14.9-2.5 24.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m45.3 339.4 2.9 12.7-11.8-18.5-3-12.9 11.9 18.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m337.2 245.5-12.9-3 4.1 8.5 13.1 2.6-4.3-8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m255.5 164.1-22-2.8-.2 19 21.9 1.5.3-17.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m401.9 224.5-16.3-9.3 2.7-12.8 16.5 10.6-2.9 11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3000"
              d="m103.6 25.7-27.3 2.6 7-12.5 25.5-2.1-5.2 12z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5900"
              d="m70.5 44.2-22.9 7.1 7.2-16.5 21.5-6.5-5.8 15.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m370.9 272.2-6.6-3.7 6.3-1 6.7 4.1-6.4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m377.3 271.6-6.7-4.1 6.2-3 6.8 4.7-6.3 2.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000084"
              d="m102.4 380.9 2.4 12.3-14.9-4.7-2.5-12.4 15 4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m364.5 271-6.4-3.3 6.2.8 6.6 3.7-6.4-1.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m197.2 161.5-11.9 3.1v22.8l11.9-4.3v-21.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a4ff"
              d="m383.6 269.2-6.8-4.7 6.1-4.9 6.8 5.5-6.1 4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m171.8 256.7 3.6 11-6.2 20.4-2.8-11.6 5.4-19.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b"
              d="m143.9 357.1 1.6 14-13.6 7.3-1.7-13.9 13.7-7.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m169.2 288.1 4.6 11.7-8.9 17.9-3.7-12.2 8-17.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ff1600" d="m139.5 15.4-30.7-1.7 6-8.5 28.7 2.2-4 8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m298.5 189.4-20.9-4.5.5 15.7 21 3.3-.6-14.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00a0ff" d="m358.5 268-6.4-3.2 6 2.9 6.4 3.3-6-3z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0028ff"
              d="m33.4 320.7 3 12.9-10.2-21-3.2-13.2 10.4 21.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#06ecf1"
              d="m174.2 224.7 1.3 9.7-3.7 22.3-.6-10.4 3-21.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m363.4 120.6-31.9-15.5-2.1-12.8 31.4 16.3 2.6 12z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m277.9 168.6-22.4-4.5-.3 17.7 22.4 3.1.3-16.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b4ff"
              d="m389.7 265.1-6.8-5.5 5.6-6.6 7 6.3-5.8 5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m333.6 236.1-12.7-3.7 3.4 10.1 12.9 3-3.6-9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6400"
              d="m288.5 56.2-37.8-14.4-1.4-7.1 36.5 14.7 2.7 6.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9100"
              d="M42 70.7 24.2 82l6.5-20.1 16.9-10.6L42 70.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#46ffb1"
              d="m404.7 213-16.4-10.6 1.9-13.4 16.5 11.8-2 12.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#39ffbe"
              d="m316.7 208.4-17.6-4.5 1.5 13.5 17.8 3.5-1.7-12.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f20"
              d="m212.2 22.5-35.8-9.3 2.2-4.2 33.9 9.4-.3 4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#adff49"
              d="m391.1 161.9-25.1-14-.9-14.1 25 15 1 13.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m178.2 193.5-2.5 7.7-1.5 23.5 2.8-8.6 1.2-22.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m352.8 263.4-6.2-3.3 5.5 4.7 6.4 3.2-5.7-4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m326.7 81.3-35.9-15.8-2.3-9.3 35 16.2 3.2 8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0014ff"
              d="m164.9 317.7 2.6 13.3-11 14.9-2.2-13.6 10.6-14.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b4ff43"
              d="m233.9 141.9-20.2-2.3-.1 20.8 19.9.9.4-19.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m395.5 259.3-7-6.3 5.2-8.2 7 7.3-5.2 7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00008d"
              d="m117.4 381.7 2.2 12.3-14.8-.8-2.4-12.3 15 .8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3800"
              d="m249.3 34.7-37.1-12.2.3-4.1 35.3 12.2 1.5 4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#13fce4"
              d="M6.2 237 8 251.2l-4.2-25.7-1.9-14.3L6.2 237z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#adff49"
              d="m256.2 146.2-22.3-4.3-.4 19.4 22 2.8.7-17.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b7ff40"
              d="m213.7 139.6-16.8-.3.3 22.2 16.4-1.1.1-20.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f60b00"
              d="m176.4 13.2-32.9-5.8 4.3-4.4 30.8 6-2.2 4.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#80ff77" d="m185.3 164.6-7.1 5v23.9l7.1-6.1v-22.8z" />
          </g>
          <g clipPath="url(#a)">
            <path fill="#97ff60" d="M4 169.4 0 185l.5-25.8 4-15.4-.5 25.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c0ff"
              d="m347.7 257.1-6.2-3.5 5.1 6.5 6.2 3.3-5.1-6.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m23 299.4 3.2 13.2-8.4-23.1-3.3-13.4 8.5 23.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1fffd7"
              d="m330.9 225.4-12.5-4.5 2.5 11.5 12.7 3.7-2.7-10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m400.7 252.1-7.1-7.3 4.5-9.6 7.1 8.4-4.5 8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m298.8 174.5-20.9-5.9-.3 16.3 20.9 4.5.3-14.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#66ff90"
              d="M406.7 200.8 390.2 189l.9-13.6 16.5 12.9-.9 12.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fc0"
              d="m360.8 108.6-31.4-16.3-2.7-11 30.8 17 3.3 10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#aaff4d"
              d="m278.9 152.1-22.7-5.9-.7 17.9 22.4 4.5 1-16.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#baff3c"
              d="m196.9 139.3-12.3 1.9.7 23.4 11.9-3.1-.3-22.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m316 195.1-17.5-5.7.6 14.5 17.6 4.5-.7-13.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="m285.8 49.4-36.5-14.7-1.5-4.1 35.1 14.7 2.9 4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="M19.6 104.3 7.4 119.2l5.1-22.9L24.2 82l-4.6 22.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="m390.1 148.8-25-15-1.7-13.2 24.7 16 2 12.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f10800"
              d="m108.9 13.7-25.6 2.1 7.9-8.9 23.6-1.7-5.9 8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m343.3 249.4-6.1-3.9 4.3 8.1 6.2 3.5-4.4-7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ed"
              d="m156.5 345.9 1.5 14-12.5 11.2-1.6-14 12.6-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7a00"
              d="m323.4 72.4-34.9-16.2-2.7-6.8 33.9 16.5 3.7 6.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#df0000"
              d="m143.5 7.4-28.7-2.2 6.5-4.6L147.8 3l-4.3 4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m234.6 122.6-20.9-3.8v20.8l20.2 2.3.7-19.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fa0f00"
              d="M212.5 18.4 178.6 9l2.3-.6 31.8 9.2-.2.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2500"
              d="m76.3 28.3-21.5 6.5 8.5-13.1 20-5.9-7 12.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m405.2 243.6-7.1-8.4 3.8-10.7 7.1 9.4-3.8 9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009f"
              d="m131.9 378.4 2 12.4-14.3 3.2-2.2-12.3 14.5-3.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2500"
              d="m247.8 30.6-35.3-12.2.2-.8 33.5 12.1 1.6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#dbff1c"
              d="m257.5 128.4-22.9-5.8-.7 19.3 22.3 4.3 1.3-17.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ebff0c"
              d="m213.7 118.8-17.5-1.6.7 22.1 16.8.3v-20.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m175.5 234.4 4.2 10.4-4.3 22.9-3.6-11 3.7-22.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m329.2 213.8-12.5-5.4 1.7 12.5 12.5 4.5-1.7-11.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m175.4 267.7 5.4 11.2-7 20.9-4.6-11.7 6.2-20.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m175.7 201.2 1.6 9-1.8 24.2-1.3-9.7 1.5-23.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#df0000" d="m178.6 9-30.8-6 4.6-.6 28.5 6-2.3.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000b2"
              d="m75.3 379.9 2.6 10.4-13.7-12-2.9-10.6 14 12.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#8aff6d"
              d="m407.6 188.3-16.5-12.9v-13.5l16.5 14.1v12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000da"
              d="m61.3 367.7 2.8 10.6-12.7-15.2-3.2-11 13.1 15.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a7ff50"
              d="m299.9 159.4-21.1-7.3-.9 16.5 20.9 5.9 1.1-15.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#80ff77" d="m178.2 169.6-2.5 6.8v24.8l2.5-7.7v-23.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m339.6 240.5-6-4.4 3.6 9.4 6.1 3.9-3.7-8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00a8ff" d="m369 276.5 1.8-4.3 6.5-.6-1.9 4.7-6.4.2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffab00"
              d="m357.5 98.3-30.8-17-3.3-8.9 30.2 17.4 3.9 8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m14.5 276.1 3.3 13.4-6.4-24.5L8 251.2l6.5 24.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d4ff23"
              d="m280.5 135.8-23-7.4-1.3 17.8 22.6 5.9 1.7-16.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="m362.8 275 1.7-4 6.3 1.2-1.8 4.3-6.2-1.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f50"
              d="M47.6 51.3 30.7 61.9l8.4-17.1 15.7-10-7.2 16.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m1.9 211.2 1.9 14.3-1.9-26.1L0 185l1.9 26.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00009b"
              d="m89.9 388.5 2.3 10.2-14.3-8.4-2.6-10.4 14.6 8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3f00"
              d="m282.9 45.3-35.1-14.7-1.6-.9 33.5 14.5 3.2 1.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="m375.4 276.3 1.9-4.7 6.3-2.4-2 5.2-6.2 1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="m184.6 141.2-7.6 4 1.2 24.4 7.1-5-.7-23.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0050ff"
              d="m173.8 299.8 3 13-9.3 18.2-2.6-13.3 8.9-17.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m316.3 181.5-17.5-7-.3 14.9 17.5 5.7.3-13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#30ffc7"
              d="m409 233.9-7.1-9.4 2.8-11.5 7.2 10.5-2.9 10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m388.1 136.6-24.7-16-2.6-12 24.5 16.9 2.8 11.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00b4ff" d="m356.8 271.9 1.7-3.9 6 3-1.7 4-6-3.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m48.2 352.1 3.1 11-11.5-18.2-3.4-11.3 11.8 18.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6400"
              d="m319.7 65.9-33.9-16.5-2.9-4.1 32.7 16.5 4.1 4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m381.7 274.4 1.9-5.2 6.1-4.1-2 5.8-6 3.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="gold" d="m235.5 104-21.8-5.2v20l20.9 3.8.9-18.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m196.2 117.2-13.1.7 1.4 23.3 12.4-1.9-.7-22.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ed0400"
              d="m212.7 17.6-31.8-9.2 2.4 3 29.6 8.9-.2-2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1e00"
              d="m246.2 29.7-33.5-12.1.2 2.7L244.5 32l1.7-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m259.2 111.3-23.7-7.3-.9 18.6 22.9 5.8 1.7-17.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c0ff"
              d="m351.2 267.3 1.6-3.9 5.7 4.6-1.7 4-5.6-4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m4.5 143.7-4 15.5 3-24.7 3.9-15.3-2.9 24.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000092"
              d="m104.8 393.2 2 10.2-14.6-4.7-2.3-10.2 14.9 4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#fc0" d="m213.7 98.8-18.5-3 1 21.4 17.5 1.6v-20z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m387.7 270.9 2-5.8 5.7-5.8-2.1 6.6-5.6 5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5dff9a"
              d="m328.4 201.6-12.4-6.5.7 13.3 12.5 5.4-.8-12.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#26ffd1"
              d="m336.9 230.6-6-5.2 2.7 10.7 6.1 4.4-2.8-9.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#aaff4d"
              d="m407.6 176-16.5-14.1-1-13.1 16.4 15.1 1.1 12.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#c80000" d="M147.8 3 121.3.6l6.9-.6 24.2 2.4-4.6.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c4"
              d="m145.5 371.1 1.9 12.5-13.5 7.2-2.1-12.4 13.7-7.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m346.1 261.3 1.6-4.2 5.1 6.3-1.6 3.9-5.1-6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#cd0000"
              d="M114.8 5.2 91.2 6.9 99.8 2 121.3.6l-6.5 4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ceff29"
              d="m302 144.6-21.5-8.8-1.7 16.3 21.1 7.3 2.1-14.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3800"
              d="m279.7 44.2-33.5-14.5-1.6 2.3 31.8 14 3.3-1.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m282.9 120.2-23.7-8.9-1.7 17.1 23 7.4 2.4-15.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#4dffaa"
              d="m411.9 223.5-7.1-10.5 1.9-12.2 7.1 11.6-1.9 11.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0030ff"
              d="m36.4 333.6 3.4 11.3-10-20.6-3.6-11.7 10.2 21z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d10000"
              d="m180.9 8.4-28.5-6 4.7 3.3 26.2 5.7-2.4-3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9100"
              d="m353.6 89.8-30.1-17.4-3.8-6.5L349 83.5l4.6 6.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0014ff"
              d="m167.5 331 1.6 14.1-11 14.8-1.6-14 11-14.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m236.7 86.6-23-6.7v18.9l21.8 5.2 1.2-17.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m393.4 265.9 2.1-6.6 5.2-7.2-2.2 7.5-5.1 6.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a4ff53"
              d="m317.6 167.7-17.7-8.3-1.1 15.1 17.5 7 1.3-13.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f50"
              d="m315.6 61.8-32.7-16.5-3.2-1.1 31.5 16.3 4.4 1.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m385.3 125.5-24.5-16.9-3.3-10.3 24.1 17.5 3.7 9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1e00"
              d="m244.6 32-31.7-11.7.2 6.1 29.8 11 1.7-5.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8d00"
              d="M24.2 82 12.5 96.3l7.3-20.5 10.9-13.9L24.2 82z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb600"
              d="m261.4 95.3-24.7-8.7-1.2 17.4 23.7 7.3 2.2-16z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f10800"
              d="m212.9 20.3-29.6-8.9 2.4 6.7 27.4 8.3-.2-6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e40000"
              d="m83.3 15.8-20 5.9 9.8-9.4 18.1-5.4-7.9 8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m341.8 253.9 1.5-4.5 4.4 7.7-1.6 4.2-4.3-7.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m195.2 95.8-14.3-.6 2.2 22.6 13.1-.6-1-21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m213.7 79.9-19.9-4.3 1.4 20.2 18.5 3V79.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000096"
              d="m119.6 394 1.7 10.2-14.5-.8-2-10.2 14.8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m183.1 117.8-8.4 2.9 2.3 24.5 7.6-4-1.5-23.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m335.1 219.9-5.9-6.1 1.7 11.6 6 5.2-1.8-10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#13fce4"
              d="m8 251.2 3.4 13.8-4.2-25.4-3.4-14.1L8 251.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3800"
              d="m276.4 46-31.9-14-1.7 5.4 30.3 13.4 3.3-4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m177 145.2-2.8 5.9 1.5 25.3 2.5-6.8-1.2-24.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m328.7 189.2-12.4-7.7-.3 13.6 12.4 6.5.3-12.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7e00"
              d="m238 70.8-24.4-8 .1 17.1 23 6.7 1.3-15.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#09f0ee"
              d="m398.5 259.6 2.2-7.5 4.5-8.5-2.2 8.3-4.5 7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#83ff73" d="m175.7 176.5 1.6 8.2v25.5l-1.6-9v-24.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc400"
              d="m285.9 105.7-24.5-10.4-2.2 16 23.7 8.9 3-14.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2900"
              d="m242.9 37.4-29.8-11 .2 9.3 27.9 10.2 1.7-8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m177.3 210.2 4.6 9.9-2.2 24.8-4.2-10.5 1.8-24.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9100"
              d="m263.9 80.9-25.8-10.1-1.4 15.8 24.7 8.7 2.5-14.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#caff2c"
              d="m406.5 163.9-16.4-15.1-2-12.2 16.3 16 2.1 11.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6aff8d"
              d="m413.8 212.4-7.1-11.6.9-12.4 7.2 12.6-1 11.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m304.8 130.5-21.9-10.3-2.4 15.6 21.5 8.8 2.8-14.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m179.7 244.9 5.8 10.7-4.7 23.3-5.4-11.2 4.3-22.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7a00"
              d="m349 83.5-29.3-17.6-4.1-4.1 28.5 17.7 4.9 4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="m311.2 60.5-31.5-16.3-3.3 1.8 30.2 15.9 4.6-1.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1300"
              d="m213.1 26.4-27.4-8.3 2.3 10 25.3 7.6-.2-9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d60000"
              d="m183.3 11.4-26.2-5.7 4.7 7.1 23.9 5.3-2.4-6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5900"
              d="m239.5 57.1-26-9.2.1 14.9 24.4 8 1.5-13.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#97ff60" d="m0 185 1.9 14.4.5-25.6-1.9-14.6L0 185z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3b00"
              d="m241.2 45.9-27.9-10.2.2 12.2 26.1 9.2 1.6-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0070ff"
              d="m26.2 312.6 3.6 11.7-8.3-22.5-3.7-12.3 8.4 23.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m338.2 245.5 1.4-5 3.7 8.9-1.5 4.6-3.6-8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4300"
              d="m273.1 50.8-30.3-13.4-1.6 8.5 28.7 12.4 3.2-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m213.6 62.8-21.5-5.5 1.7 18.3 19.9 4.3-.1-17.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6f00"
              d="m266.8 68.4-27.2-11.3-1.5 13.7 25.8 10.1 2.9-12.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c7ff30"
              d="m319.8 154.3-17.8-9.7-2.1 14.8 17.7 8.3 2.2-13.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1e00"
              d="m54.8 34.8-15.7 10 10-13.7 14.2-9.4-8.5 13.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b00"
              d="M152.4 2.4 128.2 0l7.1 3.4 21.8 2.3-4.7-3.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffbd00"
              d="m381.6 115.8-24.1-17.5-3.9-8.5 23.5 18 4.5 8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f50"
              d="m269.9 58.3-28.7-12.4-1.6 11.2 27.2 11.3 3.1-10.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m180.8 278.9 3.2 12.8-7.2 21.1-3-13 7-20.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2900"
              d="M213.3 35.7 188 28.1l2.1 13.2 23.4 6.6-.2-12.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4700"
              d="m213.5 47.9-23.4-6.6 2 16 21.5 5.5-.1-14.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa300"
              d="m289.4 92.7-25.5-11.8-2.5 14.4 24.5 10.4 3.5-13z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8900"
              d="M193.8 75.6 178 73.8l2.9 21.4 14.3.6-1.4-20.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m403 251.9 2.2-8.3 3.8-9.7-2.3 9.3-3.7 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5200"
              d="M306.6 61.9 276.4 46l-3.3 4.8 29 15.1 4.5-4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#60ff97" d="m334.4 208.6-6-7 .8 12.2 5.9 6-.7-11.2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00bcff"
              d="m352.9 279.7 9.9-4.7 6.2 1.5-10.1 4.9-6-1.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#b20000" d="M121.3.6 99.8 2l9.2-.8L128.2 0l-6.9.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m358.9 281.4 10.1-4.9 6.4-.2-10.3 5.2-6.2-.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000f1"
              d="m158.1 359.9 1.7 12.7-12.4 11-1.9-12.5 12.6-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m347 276.5 9.8-4.6 6 3.1-9.9 4.7-5.9-3.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="gold"
              d="m308.3 117.4-22.4-11.7-3 14.5 21.9 10.3 3.5-13.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a0ff56"
              d="m330.1 176.7-12.5-9-1.3 13.8 12.4 7.6 1.4-12.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6f00"
              d="m344.1 79.5-28.5-17.7-4.4-1.3 27.6 17.4 5.3 1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e40000"
              d="m185.7 18.1-23.9-5.3 4.5 10.7 21.7 4.6-2.3-10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8200"
              d="m293.3 81.5-26.5-13-2.9 12.4 25.5 11.8 3.9-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m7.4 119.2-3.9 15.3 5.3-23.1 3.7-15.1-5.1 22.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000a8"
              d="m133.9 390.8 1.5 10.3-14.1 3.1-1.7-10.2 14.3-3.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m180.9 95.2-9.5 1.8 3.3 23.7 8.4-2.9-2.2-22.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#30ffc7"
              d="m335.4 236.2 1.5-5.6 2.7 9.9-1.4 5-2.8-9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00bcff"
              d="m365.1 281.5 10.3-5.2 6.2-1.9-10.5 5.7-6 1.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#87ff70" d="m414.8 201-7.2-12.6V176l7.1 13.6.1 11.4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5900"
              d="m302.1 65.9-29-15.1-3.2 7.5 27.7 14.2 4.5-6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e7ff0f"
              d="m404.4 152.6-16.3-16-2.8-11.1 16 16.7 3.1 10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m341.6 271.9 9.6-4.6 5.6 4.7-9.8 4.5-5.4-4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m297.6 72.5-27.7-14.2-3.1 10.2 26.5 13 4.3-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5d00"
              d="m192.1 57.3-17.5-2.9 3.4 19.4 15.8 1.8-1.7-18.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000c4"
              d="m77.9 390.3 1.8 7.9-13.4-11.6-2.1-8.3 13.7 12z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e7ff0f"
              d="m322.9 141.6-18.1-11.1-2.8 14.1 17.8 9.7 3.1-12.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m371.1 280.1 10.5-5.7 6.1-3.5-10.7 6.3-5.9 2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m377.1 107.8-23.5-18-4.6-6.3 23.1 18.2 5 6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1300"
              d="m188 28.1-21.7-4.6 4.3 14 19.5 3.8-2.1-13.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000e8"
              d="m64.2 378.3 2.1 8.3-12.4-14.8-2.5-8.7 12.8 15.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#36ffc1"
              d="m406.7 243.2 2.3-9.3 2.9-10.4-2.4 10.2-2.8 9.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m336.7 266 9.4-4.7 5.1 6-9.6 4.6-4.9-5.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3400"
              d="m190.1 41.3-19.5-3.8 4 16.9 17.5 2.9-2-16z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m174.7 120.7-3.6 5 3.1 25.4 2.8-5.9-2.3-24.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m176.8 312.8 1.6 14.2-9.3 18.1-1.6-14.1 9.3-18.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#b00" d="m91.2 6.9-18.1 5.4L83.8 7l16-5-8.6 4.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#bf0000"
              d="m157.1 5.7-21.8-2.3 7.1 7.4 19.4 2-4.7-7.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb600"
              d="m312.5 105.8-23.1-13.1-3.5 13 22.4 11.7 4.2-11.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6800"
              d="m338.7 77.9-27.5-17.4-4.6 1.4 26.7 16.9 5.4-.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ad"
              d="m92.2 398.7 1.4 7.7-13.9-8.2-1.8-7.9 14.3 8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b4ff"
              d="m17.8 289.5 3.7 12.3-6.2-24.1-3.9-12.7 6.4 24.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m3.8 225.5 3.4 14.1-1.9-25.7-3.4-14.5 1.9 26.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#7dff7a" d="m334.6 197.2-5.9-8-.3 12.4 6 7 .2-11.4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="M30.7 61.9 19.8 75.8l9.4-17.7 9.9-13.3-8.4 17.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m377 277.2 10.7-6.3 5.6-4.9-10.8 6.8-5.5 4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0004ff"
              d="m51.4 363.1 2.5 8.7-11.2-17.7-2.9-9.1 11.6 18.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#49ffad"
              d="m333.7 226.2 1.4-6.3 1.8 10.7-1.5 5.6-1.7-10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m174.2 151.1 1.3 7.5 1.9 26.1-1.7-8.2-1.5-25.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0cf4eb" d="m332.4 259 9.4-5 4.3 7.3-9.4 4.7-4.3-7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m332.4 164.6-12.6-10.3-2.2 13.4 12.4 9 2.4-12.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m317.2 95.8-23.9-14.3-3.9 11.2 23.1 13.1 4.7-10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7e00"
              d="m178 73.8-11 .9 4.4 22.3 9.5-1.8-2.9-21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m333.3 78.8-26.7-16.9-4.5 4 25.7 16.3 5.5-3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a7ff50"
              d="m414.7 189.6-7.1-13.6-1.1-12.1 7 14.6 1.2 11.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m401.3 142.2-16-16.7-3.7-9.7 15.8 17.3 3.9 9.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m326.8 129.9-18.5-12.5-3.5 13.1 18.1 11.1 3.9-11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="M372.1 101.7 349 83.5l-4.9-4 22.4 18.2 5.6 4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#83ff73" d="m177.4 184.7 4.5 9.4v26l-4.6-9.9.1-25.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8200"
              d="m322.4 87.9-24.8-15.4-4.3 9 23.9 14.3 5.2-7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7300"
              d="m327.8 82.2-25.7-16.3-4.5 6.6 24.8 15.4 5.4-5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000a4"
              d="m106.8 403.4 1 7.6-14.2-4.6-1.4-7.7 14.6 4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a40000"
              d="M128.2 0 109 1.2l9.5 3.4 16.8-1.2-7.1-3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m409.5 233.7 2.4-10.2 1.9-11.1-2.4 11.2-1.9 10.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m382.5 272.8 10.8-6.8 5.2-6.4-11 7.5-5 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#cd0000"
              d="m161.8 12.8-19.4-2 6.9 11.2 17 1.5-4.5-10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m181.9 220.1 6.1 10.4-2.4 25.1-5.9-10.8 2.2-24.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1fffd7"
              d="m328.9 250.9 9.3-5.4 3.6 8.5-9.4 5-3.5-8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m.5 159.2 1.9 14.6 3-24.7-1.9-14.6-3 24.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#da0000"
              d="m63.3 21.7-14.2 9.5 11.4-9.9 12.6-9-9.8 9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000cd"
              d="m147.4 383.6 1.3 10.5-13.3 7-1.5-10.3 13.5-7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#003cff"
              d="m39.8 345 2.9 9.1-9.8-20-3.1-9.7 10 20.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="M174.6 54.4h-12.8l5.2 20.3 11-.8-3.4-19.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9dff5a"
              d="m335.9 185.9-5.9-9.2-1.3 12.5 5.9 8 1.3-11.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#63ff94"
              d="m332.9 215.8 1.5-7.2.7 11.3-1.4 6.3-.8-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e80000"
              d="m166.3 23.5-17-1.5 6.5 14.6 14.8.9-4.3-14z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc400"
              d="m331.5 119.5-19-13.7-4.2 11.6 18.5 12.5 4.7-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffae00"
              d="m171.4 97-4.7 4.2 4.4 24.5 3.6-5-3.3-23.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8600"
              d="m366.5 97.7-22.4-18.2-5.3-1.6 21.8 17.9 5.9 1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m335.6 153.1-12.7-11.5-3.1 12.7 12.6 10.3 3.2-11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m185.5 255.6 3.5 12.7-5 23.4-3.2-12.8 4.7-23.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#f20" d="m170.6 37.5-14.8-.9 6 17.8h12.8l-4-16.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0018ff"
              d="m169.1 345.1 1.7 12.9-11 14.6-1.7-12.7 11-14.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m397.4 133.1-15.8-17.3-4.5-8 15.6 17.7 4.7 7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0ff8e7"
              d="m387.5 267.1 11-7.5 4.5-7.7-11.2 8.3-4.3 6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m413.5 178.5-7-14.6-2.1-11.3 6.9 15.4 2.2 10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#33ffc4"
              d="m326.2 242.1 9.2-5.9 2.8 9.3-9.3 5.4-2.7-8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0000a8" d="m121.3 404.2.6 7.6-14.1-.8-1-7.6 14.5.8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6aff8d"
              d="m411.4 223.6 2.4-11.2 1-11.4-2.5 12.1-.9 10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#9f0000" d="m99.8 2-16 5 11.3-1L109 1.2l-9.2.8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m335.3 285 17.6-5.3 6 1.7-17.8 5.5-5.8-1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffab00"
              d="m336.7 110.8-19.5-15-4.7 10 19 13.7 5.2-8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m329.8 281.7 17.2-5.2 5.9 3.2-17.6 5.3-5.5-3.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8200"
              d="m360.6 95.8-21.9-17.9-5.4.9 21.2 17.5 6.1-.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m11.4 265 3.9 12.7-4.1-24.9-4-13.2 4.2 25.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8d00"
              d="m12.5 96.3-3.7 15.1 7.7-20.8 3.3-14.8-7.3 20.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m341.1 286.9 17.8-5.5 6.2.1-18.1 5.8-5.9-.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m324.5 277.1 17.1-5.2 5.4 4.6-17.3 5.2-5.2-4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a80000"
              d="m135.3 3.4-16.8 1.2 9.5 7.5 14.4-1.3-7.1-7.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m171.1 125.7.6 7 3.8 25.9-1.3-7.5-3.1-25.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m342.4 103.8-20-15.9-5.2 7.9 19.5 15 5.7-7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8200"
              d="m354.5 96.3-21.2-17.5-5.5 3.4L348.4 99l6.1-2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="m333.1 205.3 1.5-8.1-.2 11.4-1.5 7.2.2-10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#baff3c"
              d="m338.3 174.9-5.9-10.3-2.3 12.1 5.9 9.2 2.3-11z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m339.7 142.7-12.9-12.8-3.9 11.7 12.7 11.5 4.1-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m347 287.3 18.1-5.8 6-1.4-18.2 6.1-5.9 1.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#26ffd1"
              d="m391.8 260.2 11.2-8.3 3.7-8.7-11.3 9.1-3.6 7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m319.8 271.2 16.9-5.2 4.9 5.9-17.1 5.2-4.7-5.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0078ff"
              d="m29.8 324.3 3.1 9.8-8-21.9-3.4-10.4 8.3 22.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ff8900" d="m348.4 99-20.6-16.8-5.4 5.7 20 16 6-4.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m392.7 125.5-15.6-17.7-5-6.1 15.2 17.9 5.4 5.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m184 291.7 1.6 14.4-7.2 20.9-1.6-14.2 7.2-21.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="m1.9 199.4 3.4 14.5.6-25.4-3.5-14.7-.5 25.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7300"
              d="m167 74.7-6.2 3.4 5.9 23.1 4.7-4.2-4.4-22.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#4dffaa"
              d="m324.5 232.7 9.2-6.5 1.7 10-9.2 5.9-1.7-9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m411.3 168-6.9-15.4-3.1-10.4 6.9 16.1 3.1 9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1a00"
              d="m39.1 44.8-9.9 13.3 11.2-14.2 8.7-12.8-10 13.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m352.9 286.2 18.2-6.1 5.9-2.9-18.5 6.5-5.6 2.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#13fce4"
              d="m315.7 264.3 16.7-5.3 4.3 7-16.9 5.2-4.1-6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#87ff70"
              d="m412.3 213.1 2.5-12.1-.1-11.4-2.5 13 .1 10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m175.5 158.6 4.2 8.9 2.2 26.6-4.5-9.4-1.9-26.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b60000"
              d="M142.4 10.8 128 12.1l9.2 11.5 12.1-1.6-6.9-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="gold"
              d="m344.6 133.5-13.1-14-4.7 10.4 12.9 12.8 4.9-9.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="M387.3 119.6 372 101.7l-5.5-4 15 17.9 5.8 4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000fa"
              d="m159.8 372.6 1 10.7-12.1 10.8-1.3-10.5 12.4-11z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b"
              d="m135.4 401.1.2 7.6-13.7 3.1-.6-7.6 14.1-3.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m395.4 252.3 11.3-9.1 2.8-9.5-11.4 9.8-2.7 8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m358.5 283.7 18.5-6.5 5.5-4.4-18.8 7.1-5.2 3.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d4ff23"
              d="m341.5 164.6-5.9-11.5-3.2 11.5 5.9 10.3 3.2-10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3f00"
              d="m161.8 54.4-7.9 2.6 6.9 21.1 6.2-3.4-5.2-20.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9aff5d"
              d="m334.4 194.9 1.6-9-1.4 11.3-1.5 8.1 1.3-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b20000"
              d="m73.1 12.3-12.6 9L73 15.5 83.8 7l-10.7 5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000d6"
              d="m79.7 398.2.6 5.1L67.4 392l-1.1-5.4 13.4 11.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#26ffd1"
              d="m312.3 256.5 16.6-5.6 3.5 8.1-16.7 5.3-3.4-7.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000fa"
              d="m66.3 386.6 1.1 5.4-11.9-14.2-1.6-6 12.4 14.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#63ff94"
              d="m323.7 223 9.2-7.2.8 10.4-9.2 6.5-.8-9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m181.9 194.1 6.2 10.1-.1 26.3-6.1-10.4v-26z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d60000"
              d="m149.3 22-12.1 1.6 8.7 15.1 9.9-2.1-6.5-14.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#960000"
              d="M109 1.2 95.1 5.9l11.7 3.3 11.7-4.6-9.5-3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f4f802"
              d="m408.2 158.3-6.9-16.1-3.9-9.1 6.8 16.6 4 8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1300"
              d="m155.8 36.6-9.9 2.1 7.9 18.3 8-2.6-6-17.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000bf"
              d="m93.6 406.4.1 4.8-13.4-7.9-.6-5.1 13.9 8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m350.1 125.8-13.4-15-5.2 8.7 13.1 14 5.5-7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m3.5 134.5 1.9 14.6 5.3-23-1.9-14.7-5.3 23.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9c00"
              d="m381.5 115.6-15-17.9-5.9-1.9 14.6 17.8 6.3 2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a0ff56"
              d="m412.2 202.6 2.5-13-1.2-11.1-2.5 13.8 1.2 10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffab00"
              d="m166.7 101.2-.5 6.3 5.5 25.1-.6-6.9-4.4-24.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0014ff"
              d="m53.9 371.8 1.5 6-10.8-17-1.9-6.7 11.2 17.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#06ecf1"
              d="m363.7 279.9 18.8-7.1 5-5.7-19 7.6-4.8 5.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00bcff"
              d="m21.5 301.8 3.4 10.4-6.1-23.3-3.5-11.2 6.2 24.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m178.4 327 1.5 13.2-9.1 17.8-1.7-12.9 9.3-18.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#39ffbe"
              d="m309.8 248.1 16.4-6 2.7 8.8-16.6 5.6-2.5-8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ffae00" d="m356.1 119.8-13.7-16-5.7 7 13.4 15 6-6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m188 230.5 3.6 12.5-2.6 25.3-3.5-12.7 2.5-25.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m375.2 113.6-14.6-17.8-6.1.5 14.3 17.4 6.4-.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m7.2 239.6 4 13.2-1.9-25.1-4-13.8 1.9 25.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m398.1 243.5 11.4-9.8 1.9-10.1-11.5 10.6-1.8 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#eeff09"
              d="m345.7 155.3-6-12.6-4.1 10.4 6 11.5 4.1-9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9f00"
              d="m362.4 115.7-14-16.7-6 4.8 13.7 16 6.3-4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m368.8 113.7-14.3-17.4-6.1 2.7 14 16.7 6.4-2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b4ff43"
              d="m336.7 185 1.6-10.1-2.3 11-1.6 9 2.3-9.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000b6"
              d="m107.8 411-.4 4.6-13.7-4.4-.1-4.8 14.2 4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m306.1 287.5 23.6-5.8 5.6 3.3-23.9 5.9-5.3-3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffde00"
              d="m404.2 149.7-6.8-16.6-4.7-7.6 6.7 17 4.8 7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="m324 213.2 9.1-7.9-.2 10.5-9.2 7.2.3-9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m311.4 290.9 23.9-5.9 5.8 1.9L317 293l-5.6-2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m301.1 282.8 23.4-5.7 5.2 4.6-23.6 5.8-5-4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00d0ff" d="m317 293 24.2-6.1 5.8.4-24.4 6.4-5.6-.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="m19.8 75.8-3.3 14.8 9.8-17.9 2.9-14.6-9.4 17.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#09f0ee"
              d="m296.6 276.9 23.2-5.7 4.7 5.9-23.4 5.7-4.5-5.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#19ffde"
              d="m368.5 274.7 19-7.6 4.3-6.9-19.2 8.2-4.1 6.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0048ff"
              d="m42.7 354.1 1.9 6.7-9.3-19.2-2.4-7.5 9.8 20z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m308.1 239.1 16.4-6.4 1.7 9.4-16.4 6-1.7-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="m411 192.3 2.5-13.8-2.1-10.5-2.6 14.4 2.2 9.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#960000"
              d="m118.5 4.6-11.7 4.6 11.7 7.5 9.5-4.6-9.5-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m350.6 147.1-6-13.6-4.9 9.2 6 12.6 4.9-8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000da"
              d="m148.7 394.1-.2 7.9-12.9 6.7-.2-7.6 13.3-7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m322.6 293.7 24.4-6.4 5.9-1.1-24.8 6.7-5.5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m171.7 132.6 3.7 8.5 4.3 26.4-4.2-8.9-3.8-26z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m292.7 270.1 23-5.8 4.1 6.9-23.2 5.7-3.9-6.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m160.8 78.1-1.8 5.7 7.2 23.7.5-6.3-5.9-23.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m2.4 173.8 3.5 14.7 2.9-24.3-3.4-15.1-3 24.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6dff8a"
              d="m399.9 234.2 11.5-10.6.9-10.5-11.6 11.3-.8 9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d10000"
              d="m49.1 31.2-8.7 12.7 12.7-10.5 7.4-12.1-11.4 9.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fc0"
              d="m399.4 142.5-6.7-17-5.4-5.9 6.6 17.2 5.5 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m189 268.3 1.6 14.4-5 23.4-1.6-14.4 5-23.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ceff29"
              d="m339.9 175.7 1.7-11.1-3.3 10.3-1.6 10.1 3.2-9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#960000" d="M83.8 7 73 15.5l13.2-1.4L95.1 6 83.8 7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="m325.2 203.6 9.2-8.7-1.3 10.4-9.1 7.9 1.2-9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00b" d="m121.9 411.8-1 4.5-13.5-.7.4-4.6 14.1.8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m328.1 292.9 24.8-6.7 5.6-2.5-25.1 7.1-5.3 2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0020ff"
              d="m170.8 358 .8 11.1-10.8 14.2-1-10.7 11-14.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m372.6 268.4 19.2-8.2 3.6-7.9L376 261l-3.4 7.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m289.4 262.4 22.9-5.9 3.4 7.8-23 5.8-3.3-7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m356.2 140.4-6.1-14.6-5.5 7.7 6 13.6 5.6-6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#66ff90"
              d="m307.3 229.9 16.4-6.9.8 9.7-16.4 6.4-.8-9.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d4ff23"
              d="m408.8 182.4 2.5-14.4-3.1-9.7-2.5 15 3.1 9.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m393.9 136.8-6.6-17.2-5.8-4 6.5 17.2 5.9 4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a80000"
              d="m128 12.1-9.5 4.6 11.3 11.6 7.4-4.7-9.2-11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#19ffde"
              d="m15.3 277.7 3.5 11.2-3.9-24.2-3.7-11.9 4.1 24.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m179.7 167.5 6 9.9 2.4 26.8-6.2-10.1-2.2-26.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3400"
              d="m153.9 57-3.5 5.3 8.6 21.5 1.8-5.7-6.9-21.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0080ff"
              d="m32.9 334.1 2.4 7.5-7.7-21.1-2.7-8.3 8 21.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m362.2 135.3-6.1-15.5-6 6 6.1 14.6 6-5.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m333.4 290.8 25.1-7 5.2-3.9-25.3 7.4-5 3.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#87ff70"
              d="m400.7 224.4 11.6-11.3-.1-10.5-11.6 12 .1 9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m287 254 22.7-5.9 2.6 8.5-22.9 5.8-2.4-8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m344 167.3 1.7-12-4.1 9.3-1.7 11.1 4.1-8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb200"
              d="m388 132.8-6.5-17.2-6.3-2 6.4 17 6.4 2.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c80000"
              d="m137.2 23.6-7.4 4.7 10.8 15.4 5.3-5-8.7-15.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f10800"
              d="m145.9 38.7-5.3 5 9.8 18.6 3.5-5.3-8-18.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b1ff46"
              d="m327.3 194.4 9.4-9.4-2.3 9.9-9.2 8.7 2.1-9.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb200"
              d="m368.6 131.9-6.3-16.2-6.2 4.1 6.1 15.5 6.4-3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8d00"
              d="m8.8 111.4 1.9 14.7 7.7-20.6-1.9-14.9-7.7 20.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m376 261 19.4-8.7 2.7-8.8-19.5 9.3-2.6 8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ffab00" d="m381.6 130.6-6.4-17h-6.4l6.3 16.7 6.5.3z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffae00"
              d="m375.1 130.3-6.3-16.7-6.5 2.1 6.3 16.2 6.5-1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="m307.5 220.6 16.5-7.4-.3 9.8-16.4 6.9.2-9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m277.7 293.9 28.4-6.4 5.3 3.4-28.6 6.7-5.1-3.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m273 289 28.1-6.2 5 4.7-28.4 6.4-4.7-4.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#97ff60" d="m5.3 213.9 4 13.8.6-24.8-4-14.4-.6 25.4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ebff0c"
              d="m405.7 173.3 2.5-15-4-8.6-2.5 15.5 4 8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ed"
              d="m80.3 403.3-.6 2-12.3-10.7V392l12.9 11.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m185.6 306.1 1.5 13.4-7.2 20.7-1.5-13.1 7.2-21z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m188.1 204.2 3.6 12.4-.1 26.4-3.6-12.5.1-26.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m282.8 297.6 28.6-6.7 5.6 2.1-29 6.9-5.2-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00f" d="M67.4 392v2.6L56 381l-.5-3.2L67.4 392z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa300"
              d="m166.2 107.5 2.8 8.1 6.4 25.5-3.7-8.5-5.5-25.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m268.7 283 27.9-6.1 4.5 5.9L273 289l-4.3-6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m338.4 287.3 25.3-7.4 4.8-5.2-25.6 7.8-4.5 4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000cd"
              d="m135.6 408.7-1.5 4.7-13.1 2.9.9-4.5 13.7-3.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m285.3 245.3 22.8-6.2 1.6 9L287 254l-1.7-8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000d6"
              d="m93.7 411.2-1.2 1.6-12.8-7.5.6-2 13.4 7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m348.8 160 1.8-12.9-4.9 8.2-1.7 12 4.8-7.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00d4ff" d="m288 299.9 29-6.9 5.6.7-29.3 7.1-5.3-.9z" />
          </g>
          <g clipPath="url(#a)">
            <path fill="#890000" d="m95.1 6-8.9 8.1 13.6 3 7-7.9L95.1 6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#19ffde"
              d="m265 276.1 27.7-6 3.9 6.8-27.9 6.2-3.7-7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m160.8 383.3-.5 8.2-11.8 10.5.2-7.9 12.1-10.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a0ff56"
              d="m400.6 214.6 11.6-12-1.2-10.3-11.6 12.6 1.2 9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0024ff"
              d="m55.5 377.8.5 3.2-10.3-16.2-1.1-4 10.9 17z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1600"
              d="m29.2 58.1-2.9 14.6 11.6-14.5 2.5-14.3-11.2 14.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c7ff30"
              d="m330.4 185.9 9.5-10.2-3.2 9.3-9.4 9.4 3.1-8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m401.7 165.2 2.5-15.4-4.8-7.3-2.4 15.8 4.7 6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m378.6 252.8 19.5-9.3 1.8-9.3-19.6 9.9-1.7 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a80000"
              d="m60.5 21.3-7.4 12.1L67 27.2l6-11.7-12.5 5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m293.3 300.8 29.3-7.1 5.5-.8-29.5 7.4-5.3.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="m308.6 211.6 16.6-8-1.2 9.6-16.5 7.4 1.1-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m261.9 268.3 27.5-5.9 3.3 7.7-27.7 6-3.1-7.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m24.9 312.2 2.7 8.3-5.9-22.5-2.9-9.1 6.1 23.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m342.9 282.5 25.6-7.8 4.1-6.3-25.8 8.1-3.9 6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000cd"
              d="m107.4 415.6-1.8 1.4-13.1-4.2 1.2-1.6 13.7 4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#66ff90"
              d="m284.6 236.3 22.7-6.4.8 9.2-22.8 6.2-.7-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffde00"
              d="m354.3 154.1 1.9-13.7-5.6 6.7-1.8 12.9 5.5-5.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd300"
              d="m5.4 149.1 3.4 15.1 5.3-22.7-3.4-15.4-5.3 23z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m191.6 243 1.6 14.6-2.6 25.1-1.6-14.4 2.6-25.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m298.6 300.3 29.5-7.4 5.3-2.1-29.8 7.6-5 1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m397 158.3 2.4-15.8-5.5-5.7-2.3 16 5.4 5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b7ff40"
              d="m399.4 204.9 11.6-12.6-2.2-9.8-11.5 13.1 2.1 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m175.4 141.1 5.4 9.7 4.9 26.6-6-9.9-4.3-26.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m44.6 360.8 1.1 4-8.9-18.4-1.5-4.8 9.3 19.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m11.2 252.8 3.7 11.9-1.8-24.4-3.8-12.6 1.9 25.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m259.5 260 27.5-6 2.4 8.4-27.5 6-2.4-8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#005cff"
              d="m179.9 340.2.7 11.4-9 17.5-.8-11.1 9.1-17.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6400"
              d="m159 83.8 1.6 7.9 8.4 23.9-2.8-8.1-7.2-23.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m360.2 149.7 2-14.4-6 5.1-1.9 13.7 5.9-4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m334.4 178.3 9.6-11-4.1 8.4-9.5 10.2 4-7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#890000"
              d="m106.8 9.2-7 7.9 13.7 7.3 5-7.7-11.7-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6dff8a"
              d="m380.3 244.1 19.6-9.9.8-9.8-19.6 10.5-.8 9.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#fc0" d="m391.5 152.8 2.4-16-5.9-4-2.4 16 5.9 4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#adff49"
              d="m310.7 203 16.6-8.6-2.1 9.2-16.6 8 2.1-8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#2cffca"
              d="m346.8 276.5 25.8-8.1 3.4-7.4-25.9 8.6-3.3 6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="m284.7 227.4 22.8-6.8-.2 9.3-22.7 6.4.1-8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m248.3 303.6 31.9-7.7-4.9-4.3-32 7.6 5 4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m243.3 299.2 32-7.6-4.5-5.4-32.1 7.5 4.6 5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc400"
              d="m366.5 146.9 2.1-15-6.4 3.4-2 14.4 6.3-2.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ed"
              d="m148.5 402-2 4.9-12.4 6.5 1.5-4.7 12.9-6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m303.6 298.4 29.8-7.6 5-3.5-30.1 7.8-4.7 3.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m253.5 306.6 31.9-7.7-5.2-3-31.9 7.7 5.2 3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0000d1" d="m121 416.3-2.5 1.4-13-.7 1.9-1.4 13.6.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc400"
              d="m385.6 148.8 2.4-16-6.4-2.2-2.2 15.9 6.2 2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m257.9 251.3 27.5-6 1.6 8.7-27.5 6-1.6-8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0ff8e7"
              d="m238.7 293.7 32.1-7.5-4-6.5-32.2 7.4 4.1 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m372.9 145.8 2.2-15.5-6.5 1.6-2.1 15 6.4-1.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ceff29"
              d="m397.3 195.6 11.5-13.2-3.1-9.1-11.5 13.7 3.1 8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffbd00"
              d="m379.4 146.5 2.2-15.8-6.5-.4-2.2 15.5 6.5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m258.9 308.3 31.8-7.8-5.3-1.6-31.9 7.7 5.4 1.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m339 171.8 9.8-11.8-4.8 7.3-9.6 11 4.6-6.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2d00"
              d="m150.4 62.3.2 7.7 10 21.7-1.6-7.9-8.6-21.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m234.6 287.1 32.2-7.4-3.5-7.4-32.2 7.3 3.5 7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="m16.5 90.6 1.9 14.9 9.8-17.9-1.9-14.9-9.8 17.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m185.7 177.4 3.5 12.3 2.5 26.9-3.6-12.4-2.4-26.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9b0000"
              d="m118.5 16.7-5 7.7 13.2 11.5 3.1-7.6-11.3-11.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d4ff23"
              d="m5.9 188.5 4 14.4 2.9-23.8-4-14.9-2.9 24.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#008cff"
              d="m35.3 341.6 1.5 4.8-7.4-20.1-1.8-5.8 7.7 21.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#87ff70"
              d="m381.1 234.9 19.6-10.5-.1-9.8-19.7 11 .2 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m264.3 308.5 31.7-7.8-5.3-.2-31.8 7.8 5.4.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#8d0000"
              d="m73 15.5-6 11.7 14.7-1.9 4.5-11.2L73 15.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m313.6 195.1 16.8-9.2-3.1 8.5-16.6 8.6 2.9-7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="M350.1 269.6 376 261l2.6-8.2-26.1 9-2.4 7.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0ff8e7"
              d="m308.3 295.1 30.1-7.8 4.5-4.8-30.3 8.1-4.3 4.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0028ff"
              d="m171.6 369.1-.9 8.6-10.4 13.8.5-8.2 10.8-14.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m190.6 282.7 1.4 13.8-4.9 23-1.5-13.4 5-23.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m285.8 218.7 22.8-7.1-1.1 9-22.8 6.8 1.1-8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m18.8 288.9 2.9 9.1-3.8-23.2-3-10.1 3.9 24.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m79.7 405.3-1.3-1.1-11.6-10.1.6.5 12.3 10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#66ff90" d="m257.2 242.4 27.4-6.1.7 9-27.4 6-.7-8.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0010ff"
              d="m67.4 394.6-.6-.5L56 381.3v-.3l11.4 13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#30ffc7"
              d="m231.1 279.6 32.2-7.3-2.7-8.1-32.3 7.2 2.8 8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m394.2 187 11.5-13.7-4-8.1-11.4 14 3.9 7.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e80000"
              d="m140.6 43.7-1.4 7.5L150.6 70l-.2-7.7-9.8-18.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b00"
              d="m129.8 28.3-3.1 7.6 12.5 15.3 1.4-7.5-10.8-15.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d10000"
              d="m40.4 43.9-2.5 14.3 13.3-10.7 1.9-14.1-12.7 10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m344.3 166.5 10-12.4-5.5 5.9-9.8 11.8 5.3-5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000f1"
              d="m92.5 412.8-2-1.4-12.1-7.2 1.3 1.1 12.8 7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9f00"
              d="m169 115.6 4.7 9.6 7.2 25.6-5.5-9.7-6.4-25.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m269.5 307.3 31.6-7.8-5.1 1.2-31.7 7.8 5.2-1.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0038ff" d="M56 381v.3L46.2 366l-.5-1.2L56 381z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000e3"
              d="m134.1 413.4-3 1.6-12.6 2.7 2.4-1.4 13.2-2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9dff5a"
              d="m380.9 225.6 19.7-11-1.2-9.7-19.7 11.4 1.2 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m228.3 271.4 32.3-7.2-2-8.5-32.3 7 2 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f4f802"
              d="m390.3 179.2 11.4-14-4.7-6.9-11.3 14.3 4.6 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1fffd7"
              d="m312.6 290.6 30.3-8.1 3.9-6-30.5 8.3-3.7 5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m317.3 188.1 17.1-9.8-4 7.6-16.8 9.2 3.7-7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m215.4 312.1 32.9-8.5-5-4.4-33.1 8.4 5.2 4.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m352.5 261.8 26.1-9 1.7-8.7-26.2 9.3-1.6 8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m210.2 307.6 33.1-8.4-4.6-5.5-33.3 8.1 4.8 5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffde00"
              d="m350 162.7 10.2-13-5.9 4.4-10 12.5 5.7-3.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="m257.3 233.5 27.4-6.1-.1 8.9-27.4 6.1.1-8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#aaff4d"
              d="m287.7 210.5 23-7.5-2.1 8.6-22.8 7.1 1.9-8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000e8"
              d="m105.5 417-2.7-1.7-12.3-3.9 2 1.4 13 4.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m220.9 315.2 32.6-8.6-5.2-3-32.9 8.5 5.5 3.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m9.3 227.7 3.8 12.6.6-24-3.8-13.4-.6 24.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m205.4 301.8 33.3-8.1-4.1-6.6-33.4 7.8 4.2 6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m274.4 304.6 31.6-7.7-4.9 2.6-31.6 7.8 4.9-2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m191.7 216.6 1.5 14.7v26.3l-1.6-14.6.1-26.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9100"
              d="m10.7 126.1 3.4 15.4 7.6-20.4-3.3-15.6-7.7 20.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0008ff"
              d="m160.3 391.5-2.4 5.4-11.4 10 2-4.9 11.8-10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m385.7 172.6 11.3-14.3-5.4-5.5-11.2 14.3 5.3 5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf"
              d="m226.4 316.9 32.5-8.6-5.4-1.7-32.6 8.6 5.5 1.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a0ff"
              d="m187.1 319.5.5 11.9-7 20.2-.7-11.4 7.2-20.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf"
              d="m27.6 320.5 1.8 5.8-5.6-21.4-2.1-6.9 5.9 22.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd300"
              d="m356.1 160.4 10.4-13.5-6.3 2.8-10.2 13 6.1-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0064ff"
              d="m45.7 364.8.5 1.2-8.4-17.4-1-2.2 8.9 18.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m201.2 294.9 33.4-7.8-3.5-7.5-33.6 7.6 3.7 7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m226.3 262.7 32.3-7-1.1-8.9-32.5 7 1.3 8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="maroon"
              d="m86.2 14.1-4.5 11.2 15.2 2.5 2.9-10.7-13.6-3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b4ff43"
              d="m379.7 216.3 19.7-11.4-2.1-9.3-19.6 11.8 2 8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m380.4 167.1 11.2-14.3-6-4-10.9 14.3 5.7 4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e7ff0f"
              d="m321.8 182.1 17.2-10.3-4.6 6.5-17.1 9.8 4.5-6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m362.4 159.7 10.5-13.9-6.4 1.1-10.4 13.5 6.3-.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m232 317.2 32.3-8.7-5.4-.2-32.5 8.7 5.6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#30ffc7"
              d="m316.3 284.8 30.5-8.3 3.3-6.9-30.8 8.5-3 6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m374.7 163.1 10.9-14.3-6.2-2.4-10.8 14.2 6.1 2.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fc0"
              d="m368.6 160.6 10.8-14.1-6.5-.7-10.5 13.9 6.2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6dff8a"
              d="m354.1 253.4 26.2-9.3.8-9.2-26.3 9.6-.7 8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m258.3 225 27.5-6.3-1.1 8.7-27.4 6.2 1-8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m290.5 203 23.1-7.9-2.9 7.9-23 7.5 2.8-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m278.9 300.7 31.6-7.7-4.5 3.9-31.6 7.7 4.5-3.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#2cffca"
              d="m197.5 287.2 33.6-7.6-2.8-8.2-33.8 7.2 3 8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6000"
              d="m160.6 91.7 3.9 9.6 9.2 23.9-4.7-9.6-8.4-23.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m180.8 150.8 3.4 12.4 5 26.5-3.5-12.3-4.9-26.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0000ed"
              d="M118.5 417.8 115 416l-12.2-.7 2.7 1.7 13 .8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m14.9 264.7 3 10.1-1.7-23.4-3.1-11.1 1.8 24.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#6dff8a" d="m225 253.8 32.5-7-.4-8.9-32.4 6.8.3 9.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m237.4 315.9 32.1-8.6-5.2 1.2-32.3 8.7 5.4-1.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1a00"
              d="m26.3 72.7 1.9 15 11.6-14.5-1.9-15-11.6 14.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#caff2c"
              d="m377.7 207.4 19.6-11.8-3.1-8.6-19.5 12.1 3 8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#000cff"
              d="m78.4 404.2-1.3-3.8-10.9-9.5.6 3.2 11.6 10.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m146.5 406.9-3.6 1.9-11.8 6.2 3-1.6 12.4-6.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m183.6 321.4 31.8-9.3-5.2-4.5-32.1 9 5.5 4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m178.1 316.6 32.1-9-4.8-5.8-32.4 8.7 5.1 6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0028ff"
              d="m66.8 394.1-.6-3.2-10.1-12.1-.1 2.5 10.8 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m326.8 177.4 17.5-10.9-5.3 5.3-17.2 10.3 5-4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a40000"
              d="m53.1 33.4-1.9 14.1 14.5-6.6L67 27.2l-13.9 6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m189.3 324.8 31.6-9.6-5.5-3.1-31.8 9.3 5.7 3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0064ff"
              d="m180.6 351.6-1.1 9.2-8.8 16.9.9-8.6 9-17.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="gold"
              d="m8.8 164.2 4 14.9 5.2-22.2-3.9-15.4-5.3 22.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m36.7 346.4 1.1 2.2-7-19-1.4-3.3 7.3 20.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m194.5 278.6 33.8-7.2-2-8.7-33.9 6.9 2.1 9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#06ecf1"
              d="m173 310.5 32.4-8.7-4.2-6.9-32.8 8.3 4.6 7.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m90.5 411.4-2.1-4.3-11.3-6.7 1.3 3.8 12.1 7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m319.3 278.1 30.7-8.5 2.5-7.8-30.9 8.7-2.3 7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m354.8 244.5 26.3-9.6-.2-9.3-26.3 9.9.2 9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#840000"
              d="m99.8 17.1-2.9 10.7 15.2 7 1.4-10.4-13.7-7.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#19ffde"
              d="m282.9 295.4 31.6-7.6-4 5.2-31.6 7.7 4-5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m193.1 257.6 1.5 14.1-2.6 24.8-1.4-13.8 2.5-25.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m195.2 326.6 31.2-9.6-5.5-1.8-31.6 9.6 5.9 1.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d4ff23"
              d="m294 196.4 23.3-8.3-3.7 7-23.1 7.9 3.5-6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#aaff4d"
              d="m260.1 217 27.6-6.5-1.9 8.2-27.5 6.3 1.8-8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#004cff"
              d="m56 381.3.1-2.5-9.2-14.3-.7 1.5 9.8 15.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m242.5 313.2 31.9-8.6-4.9 2.7-32.1 8.6 5.1-2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m168.4 303.2 32.8-8.3-3.7-7.7-33 7.8 3.9 8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m374.7 199.1 19.5-12.1-3.9-7.8-19.4 12.4 3.8 7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2900"
              d="m150.6 70 2.8 9.7 11.1 21.6-3.9-9.6-10-21.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m332.3 174.1 17.7-11.4-5.7 3.8-17.5 10.9 5.5-3.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m224.7 244.7 32.4-6.8.6-8.7-32.5 6.7-.5 8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1fffd7"
              d="m21.7 298 2.1 6.9-3.6-22.1-2.3-8 3.8 23.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m102.8 415.3-2.9-4.5-11.5-3.7 2.1 4.3 12.3 3.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m201.1 326.9 30.9-9.7-5.6-.3-31.2 9.7 5.9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m192.4 269.6 33.9-6.9-1.3-8.9-33.9 6.5 1.3 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00f"
              d="m131.1 415-4.2-1.6L115 416l3.5 1.8 12.6-2.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m164.5 295 33-7.8-3-8.6-33.2 7.3 3.2 9.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#eeff09"
              d="m370.9 191.6 19.4-12.4-4.6-6.6-19.2 12.4 4.4 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#920000"
              d="m113.4 24.4-1.3 10.4L126.8 46l-.1-10.1-13.3-11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0038ff"
              d="m170.7 377.7-2.8 5.9-10 13.3 2.4-5.4 10.4-13.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffde00"
              d="m338.1 172.2 18-11.8-6.1 2.3-17.7 11.4 5.8-1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9aff5d"
              d="m354.6 235.5 26.3-9.9-1.2-9.3-26.2 10.2 1.1 9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0074ff"
              d="m46.2 366 .7-1.5-7.9-16.3-1.2.4 8.4 17.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m321.6 270.5 30.9-8.7 1.6-8.4-31 8.8-1.5 8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m154.4 331.6 29.2-10.2-5.5-4.8-29.6 9.8 5.9 5.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m148.5 326.4 29.6-9.8-5.1-6.1-30 9.3 5.5 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="m9.9 202.9 3.8 13.4 2.8-23.1-3.7-14.1-2.9 23.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m298.2 190.9 23.6-8.8-4.5 6-23.3 8.3 4.2-5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#df0000"
              d="m139.2 51.2 1.5 9.9 12.7 18.6-2.8-9.7-11.4-18.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m286.3 289.1 31.6-7.5-3.4 6.2-31.6 7.6 3.4-6.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m189.2 189.7 1.5 14.8 2.5 26.8-1.5-14.7-2.5-26.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00bcff"
              d="m160.7 335.2 28.6-10.4-5.7-3.4-29.2 10.2 6.3 3.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#09f0ee"
              d="m247.1 309.1 31.8-8.4-4.5 3.9-31.9 8.6 4.6-4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="m262.6 209.7 27.9-6.7-2.8 7.5-27.6 6.5 2.5-7.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b20000"
              d="m126.7 35.9.1 10.1 13.9 15.1-1.5-9.9-12.5-15.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf"
              d="m206.8 325.5 30.6-9.6-5.4 1.3-30.9 9.7 5.7-1.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m143 319.8 30-9.3-4.6-7.3-30.3 8.7 4.9 7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m366.5 185 19.2-12.4-5.3-5.5-19 12.6 5.1 5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5200"
              d="m18.4 105.5 3.3 15.6 9.7-17.5-3.2-15.9-9.8 17.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m344.1 171.8 18.3-12.1-6.3.7-18 11.8 6-.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9f00"
              d="m173.7 125.2 3.1 12.4 7.4 25.6-3.4-12.4-7.1-25.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m29.4 326.3 1.4 3.3-5.3-20.2-1.7-4.5 5.6 21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0028ff"
              d="m77.1 400.4-.3-6.4-10.1-8.8-.5 5.7 10.9 9.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m167 337.2 28.2-10.6-5.9-1.8-28.6 10.4 6.3 2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9aff5d"
              d="m225.2 235.9 32.5-6.7 1.4-8.3-32.6 6.6-1.3 8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m192 296.5.4 12.3-4.8 22.6-.5-11.9 4.9-23z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0040ff"
              d="m66.2 390.9.5-5.7-9.4-11.2-1.2 4.8 10.1 12.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6dff8a"
              d="m191.1 260.3 33.9-6.5-.3-9.1-34.1 6.2.5 9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m161.3 285.9 33.2-7.3-2.1-9-33.4 6.7 2.3 9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m361.4 179.6 19-12.5-5.7-4-18.8 12.5 5.5 4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="gold"
              d="m350.1 173 18.5-12.4-6.2-.9-18.3 12.1 6 1.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#00f" d="m115 416-3.6-4.6-11.5-.6 2.9 4.5 12.2.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m355.9 175.6 18.8-12.5-6.1-2.5-18.5 12.3 5.8 2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0ff8e7"
              d="m138 311.9 30.4-8.7-3.9-8.2-30.7 8 4.2 8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0018ff"
              d="m88.4 407.1-1-6.9-10.6-6.2.3 6.4 11.3 6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#890000"
              d="M67 27.2 65.7 41l15.4-2.2.6-13.5L67 27.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0018ff"
              d="m157.9 396.9-4.2 2.3-10.8 9.6 3.6-1.9 11.4-10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b1ff46"
              d="m353.4 226.5 26.3-10.2-2-8.9-26.3 10.4 2 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m303 186.5 23.8-9.1-5 4.7-23.6 8.8 4.8-4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0060ff"
              d="m56.1 378.8 1.2-4.8-8.5-13.3-1.9 3.8 9.2 14.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#6dff8a" d="m323.1 262.2 31-8.8.7-8.9-31.1 9-.6 8.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m173.3 337.5 27.8-10.6-5.9-.3-28.2 10.6 6.3.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m13.1 240.3 3.1 11.1.5-23.1-3.1-12-.5 24z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m212.2 322.6 30.3-9.4-5.1 2.7-30.6 9.6 5.4-2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b4ff"
              d="m129.4 342.4 25-10.8-5.9-5.2-25.6 10.3 6.5 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m289 281.8 31.5-7.4-2.6 7.2-31.6 7.5 2.7-7.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m251.3 303.6 31.6-8.2-4 5.3-31.8 8.4 4.2-5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c0ff"
              d="m122.9 336.7 25.6-10.3-5.5-6.6-26.1 9.7 6 7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a8ff"
              d="m37.7 348.6 1.3-.4-6.5-17.8-1.7-.8 6.9 19z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="m266 203.3 28-6.9-3.5 6.6-27.9 6.7 3.4-6.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d10000"
              d="m38 58.2 1.8 15L53 62.6l-1.8-15.1L38 58.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a8ff"
              d="m136.2 346.3 24.5-11.1-6.3-3.6-25 10.8 6.8 3.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#23ffd4"
              d="m133.8 303 30.7-8-3.2-9.1-31 7.4 3.5 9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0010ff"
              d="m99.9 410.8-1.8-7.2-10.7-3.4 1 6.8 11.5 3.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m116.9 329.5 26.1-9.7-5-7.9-26.5 9.1 5.4 8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m159 276.3 33.4-6.7-1.3-9.3-33.6 6.1 1.5 9.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0008ff"
              d="m142.9 408.8-4.8-1.3-11.2 5.9 4.2 1.6 11.8-6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m190.6 250.9 34.1-6.2.5-8.8-34.1 5.8-.5 9.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b1ff46"
              d="m226.5 227.5 32.6-6.6 2.2-7.7-32.6 6.4-2.2 7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m351.4 217.8 26.3-10.4-3-8.3-26.1 10.5 2.8 8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a8ff"
              d="m143.1 348.5 23.9-11.3-6.3-2-24.5 11.1 6.9 2.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m308.2 183.6 24.1-9.5-5.5 3.3-23.8 9.1 5.2-2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a8ff"
              d="m187.6 331.4-1.3 9.8-6.8 19.6 1.1-9.2 7-20.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c0ff"
              d="m179.4 336 27.4-10.5-5.7 1.4-27.8 10.6 6.1-1.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0040ff"
              d="m76.8 394 2.1-8.4-9.3-8.1-2.9 7.7 10.1 8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#08f"
              d="m46.9 364.5 1.9-3.8-7.3-15.2-2.5 2.7 7.9 16.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m17.9 274.8 2.3 8-1.6-22.3-2.4-9.1 1.7 23.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0058ff"
              d="m66.7 385.2 2.9-7.7-8.7-10.4-3.6 6.9 9.4 11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="m14.1 141.5 3.9 15.4 7.5-19.9-3.8-15.9-7.6 20.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#06ecf1"
              d="m111.5 321 26.6-9.1-4.3-8.9-27 8.3 4.7 9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a0ff"
              d="m109.2 353.6 20.2-11.2-6.5-5.7-20.8 10.7 7.1 6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m217.1 318.3 30-9.2-4.6 4.1-30.3 9.5 4.9-4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m102.1 347.4 20.8-10.7-6-7.2-21.4 10 6.6 7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m193.2 231.3 1.5 14.4-.1 25.9-1.5-14 .1-26.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0034ff"
              d="m87.4 400.2 1.2-8.9-9.7-5.7-2.1 8.4 10.6 6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#83ff73" d="m323.7 253.5 31.1-9-.2-9-31.1 9 .2 9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0008ff"
              d="m126.9 413.4-4.4-4.5-11.1 2.5 3.6 4.6 11.9-2.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#39ffbe"
              d="m130.3 293.3 31-7.4-2.3-9.6-31.2 6.6 2.5 10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6000"
              d="m164.5 101.3 2.7 12.4 9.6 23.9-3.1-12.4-9.2-23.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0094ff"
              d="m116.6 357.9 19.6-11.6-6.8-3.9-20.2 11.2 7.4 4.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e1ff16"
              d="m269.9 197.9 28.3-7-4.2 5.5-28 6.9 3.9-5.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m254.7 297.1 31.6-8-3.4 6.3-31.6 8.3 3.4-6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m290.8 273.7 31.6-7.3-1.9 8-31.5 7.4 1.8-8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0074ff"
              d="m57.3 374 3.6-6.9-7.8-12.3-4.3 5.9 8.5 13.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a8ff"
              d="m149.9 348.8 23.4-11.3-6.3-.3-23.9 11.3 6.8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m348.6 209.6 26.1-10.5-3.8-7.5-25.9 10.6 3.6 7.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m95.5 339.5 21.4-10-5.4-8.5-21.9 9.1 5.9 9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m313.7 182 24.4-9.8-5.8 1.9-24.1 9.5 5.5-1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#26ffd1"
              d="m23.8 304.9 1.7 4.5-3.4-20.9-1.9-5.7 3.6 22.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0014ff"
              d="m111.4 411.4-2.6-7.2-10.7-.5 1.8 7.1 11.5.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6dff8a"
              d="m157.5 266.4 33.6-6.1-.5-9.4-33.6 5.5.5 10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="maroon"
              d="m81.7 25.3-.6 13.5 15.8 2.3V27.8l-15.2-2.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#005cff"
              d="m78.9 385.6 5.5-9.9-8.5-7.5-6.3 9.3 9.3 8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#008cff"
              d="m94.3 364.9 14.9-11.3-7.1-6.2-15.6 10.7 7.8 6.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0070ff"
              d="m69.6 377.5 6.3-9.3-8-9.4-7 8.3 8.7 10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m106.8 311.3 27-8.3-3.5-9.7-27.3 7.3 3.8 10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m86.5 358.1 15.6-10.7-6.6-7.9-16.3 9.9 7.3 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0094ff"
              d="m124.2 360.3 18.9-11.8-6.9-2.2-19.6 11.6 7.6 2.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#002cff"
              d="m98.1 403.7.4-9.2-9.9-3.2-1.2 8.9 10.7 3.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m184.2 163.2 1.6 14.9 4.9 26.4-1.5-14.8-5-26.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf"
              d="m185.2 332.9 27-10.2-5.4 2.8-27.4 10.5 5.8-3.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0070ff"
              d="m179.5 360.8-3.2 6.6-8.4 16.2 2.8-5.9 8.8-16.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9aff5d"
              d="m191.1 241.7 34.1-5.8 1.3-8.4-34 5.4-1.4 8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m228.7 219.6 32.6-6.4 2.9-6.9-32.5 6.4-3 6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0074ff"
              d="m84.4 375.7 9.9-10.9-7.8-6.8-10.6 10.2 8.5 7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0080ff"
              d="m102.4 369.6 14.2-11.7-7.4-4.3-14.9 11.2 8.1 4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#004cff"
              d="m88.6 391.3 4.7-10.4-8.9-5.2-5.5 9.9 9.7 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m30.8 329.6 1.7.8-4.9-18.9-2.1-2.1 5.3 20.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e7ff0f"
              d="m345 202.2 25.9-10.6-4.4-6.6-25.8 10.6 4.3 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0084ff"
              d="M75.9 368.2 86.5 358l-7.2-8.6-11.4 9.4 8 9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m319.4 181.9 24.7-10.1-6 .4-24.4 9.8 5.7-.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e0fb"
              d="m89.6 330.1 21.9-9.1-4.7-9.7-22.3 8.2 5.1 10.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b4ff"
              d="m79.2 349.4 16.3-9.9-5.9-9.4-16.9 9 6.5 10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#008cff"
              d="m60.9 367.1 7-8.3-7.2-11.3-7.6 7.3 7.8 12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b4ff"
              d="m39 348.2 2.5-2.7-6.1-16.5-2.9 1.4 6.5 17.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m93.3 380.9 9.1-11.3-8.1-4.8-9.9 10.9 8.9 5.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#9aff5d" d="m323.5 244.5 31.1-9-1.1-9-31.1 9 1.1 9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m48.8 360.7 4.3-5.9-6.8-13.9-4.8 4.6 7.3 15.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#13fce4"
              d="m221.4 312.5 29.9-8.8-4.2 5.4-30 9.2 4.3-5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m156.6 347.3 22.8-11.3-6.1 1.5-23.4 11.3 6.7-1.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m12.8 179.1 3.7 14.1 5.1-21.4-3.6-14.9-5.2 22.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m127.8 282.9 31.2-6.6-1.5-9.9-31.3 5.8 1.6 10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#eeff09"
              d="m274.4 193.9 28.6-7.3-4.8 4.3-28.3 7.1 4.5-4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f4f802"
              d="m340.7 195.6 25.8-10.6-5.1-5.3-25.5 10.5 4.8 5.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a0ff"
              d="m67.9 358.8 11.3-9.4-6.5-10.3-12 8.4 7.2 11.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m325.1 183.3 25-10.3-6-1.2-24.7 10.1 5.7 1.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#007cff"
              d="m110.7 372.3 13.5-12-7.6-2.4-14.2 11.7 8.3 2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0094ff"
              d="m131.7 360.7 18.2-11.9-6.8-.3-18.9 11.8 7.5.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#04f"
              d="m167.9 383.6-4.6 3-9.6 12.6 4.2-2.3 10-13.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1e00"
              d="m28.2 87.7 3.2 15.9 11.5-14.2-3.1-16.2-11.6 14.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#66ff90"
              d="m291.9 265 31.6-7.1-1.1 8.5-31.6 7.3 1.1-8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0048ff"
              d="m98.5 394.5 3.9-10.7-9.1-2.9-4.7 10.4 9.9 3.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m335.9 190.2 25.5-10.5-5.5-4.1-25.3 10.5 5.3 4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m257.5 289.5 31.5-7.7-2.7 7.3-31.6 8 2.8-7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m330.6 186.1 25.3-10.5-5.8-2.6-25 10.3 5.5 2.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#36ffc1"
              d="m103 300.6 27.3-7.3-2.5-10.4-27.6 6.5 2.8 11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0064ff"
              d="m102.4 383.8 8.3-11.5-8.3-2.7-9.1 11.3 9.1 2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m72.7 339.1 16.9-9-5.1-10.6-17.4 7.9 5.6 11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2900"
              d="m153.4 79.7 2.3 12.5 11.5 21.5-2.7-12.4-11.1-21.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#87ff70" d="m157 256.4 33.6-5.5.5-9.2-33.6 5-.5 9.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0030ff"
              d="m108.8 404.2-.5-9.2-9.8-.5-.4 9.1 10.7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#13fce4"
              d="m84.5 319.5 22.3-8.2-3.8-10.7-22.7 7.2 4.2 11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m194.6 271.6.3 13-2.5 24.2-.4-12.3 2.6-24.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="m53.1 354.8 7.6-7.3-6.2-12.8-8.2 6.2 6.8 13.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#002cff"
              d="m153.7 399.2-5.4-.7-10.2 9 4.8 1.3 10.8-9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a80000"
              d="M51.2 47.5 53 62.6l14.5-6.5L65.7 41l-14.5 6.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00dcfe"
              d="m190.5 328.2 26.6-9.9-4.9 4.4-27 10.2 5.3-4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="maroon" d="M96.9 27.8v13.3l15.7 6.7-.5-13-15.2-7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0020ff"
              d="m122.5 409-3.4-7.1-10.3 2.3 2.6 7.2 11.1-2.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m231.7 212.7 32.5-6.4 3.7-5.8-32.6 6.2-3.6 6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c0ff"
              d="m60.7 347.5 12-8.4-5.6-11.7-12.6 7.3 6.2 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0020ff"
              d="m138.1 407.5-5.1-4.1-10.5 5.5 4.4 4.5 11.2-5.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b1ff46"
              d="m192.5 232.9 34-5.5 2.2-7.8-34 5.2-2.2 8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#b1ff46" d="m322.4 235.5 31-9-2-8.7-31 9 2 8.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ceff29"
              d="m13.7 216.3 3 12 2.8-22.2-3-12.9-2.8 23.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#007cff"
              d="m118.9 372.7 12.8-12-7.5-.4-13.5 12 8.2.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m279.3 191.1 28.9-7.5-5.2 2.9-28.6 7.4 4.9-2.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00bcff"
              d="m162.8 343.9 22.4-11-5.8 3.1-22.8 11.3 6.2-3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m41.5 345.5 4.8-4.6-5.6-15.3-5.3 3.4 6.1 16.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#009cff"
              d="m139 359 17.6-11.7-6.7 1.5-18.2 11.9 7.3-1.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6dff8a"
              d="m126.2 272.2 31.3-5.8-.5-10-31.4 5.1.6 10.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#004cff" d="m108.3 395 3.1-10.7-9-.5-3.9 10.7 9.8.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#23ffd4"
              d="m225.1 305.5 29.6-8.4-3.4 6.6-29.9 8.8 3.7-7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0064ff"
              d="m111.4 384.3 7.5-11.6-8.2-.4-8.3 11.5 9 .5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#09f0ee"
              d="m67.1 327.4 17.4-7.9-4.2-11.7-17.9 6.8 4.7 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#df0000"
              d="m140.7 61.1 1.8 12.7 13.2 18.4-2.3-12.5-12.7-18.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#7dff7a" d="m292 256 31.7-7-.2 8.9-31.6 7.1.1-9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m32.5 330.4 2.9-1.4-4.5-17.6-3.3.1 4.9 18.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m16.2 251.4 2.4 9 .5-21.9-2.3-10.2-.6 23.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#920000"
              d="m112.1 34.8.5 13 15.4 11-1.2-12.8-14.7-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m259.4 281 31.4-7.3-1.8 8.1-31.5 7.7 1.9-8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m100.2 289.4 27.6-6.5-1.6-10.7-27.8 5.5 1.8 11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#30ffc7"
              d="m80.3 307.8 22.7-7.2-2.8-11.2-23.1 6.1 3.2 12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m320.4 226.8 31-9-2.8-8.2-30.9 9 2.7 8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#2cffca"
              d="m25.5 309.4 2.1 2.1-3.2-19.6-2.3-3.4 3.4 20.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d4ff"
              d="m46.3 340.9 8.2-6.2-5.1-14-8.7 4.9 5.6 15.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m20.2 282.8 1.9 5.7-1.5-21.1-2-6.9 1.6 22.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b20000"
              d="m126.8 46 1.2 12.8 14.5 15-1.8-12.7L126.8 46z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m54.5 334.7 12.6-7.3-4.7-12.8-13 6.1 5.1 14z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m284.5 189.8 29.2-7.8-5.5 1.6-28.9 7.5 5.2-1.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9dff5a"
              d="m157.5 246.7 33.6-5 1.4-8.8-33.6 4.5-1.4 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e7ff0f"
              d="m235.3 206.7 32.6-6.2 4.2-4.8-32.5 6.2-4.3 4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#09f0ee"
              d="m195.1 322 26.3-9.5-4.3 5.8-26.6 9.9 4.6-6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#06ecf1"
              d="m192.4 308.8-1.4 10.5-4.7 21.9 1.3-9.8 4.8-22.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#003cff"
              d="m119.1 401.9-1.3-9-9.5 2.1.5 9.2 10.3-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#08f"
              d="M126.9 370.9 139 359l-7.3 1.7-12.8 12 8-1.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m190.7 204.5 1.5 14.8 2.5 26.4-1.5-14.4-2.5-26.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9f00"
              d="m176.8 137.6 1.6 15 7.4 25.5-1.6-14.9-7.4-25.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#c7ff30" d="m194.7 224.8 34-5.2 3-6.9-34 4.8-3 7.3z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5900"
              d="m21.7 121.1 3.8 15.9 9.5-17.1-3.6-16.3-9.7 17.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d0ff"
              d="m168.5 338.8 22-10.6-5.3 4.7-22.4 11 5.7-5.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m317.7 218.6 30.9-9-3.6-7.4-30.7 8.9 3.4 7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="m145.8 355.4 17-11.5-6.2 3.4L139 359l6.8-3.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m289.9 189.9 29.5-8-5.7.1-29.1 7.8 5.3.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0070ff"
              d="m120.1 382.3 6.8-11.4-8 1.8-7.5 11.6 8.7-2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m117.8 392.9 2.3-10.6-8.7 2-3.1 10.7 9.5-2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#87ff70"
              d="m125.6 261.5 31.4-5.1.5-9.7-31.5 4.2-.4 10.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#94ff63" d="M291.3 246.9 323 240l.7 9-31.7 7-.7-9.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#26ffd1"
              d="m62.4 314.6 17.9-6.8-3.2-12.3-18.1 5.6 3.4 13.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#39ffbe"
              d="m227.9 297.5 29.6-8-2.8 7.6-29.6 8.4 2.8-8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0038ff"
              d="m133 403.4-4.2-6.6-9.7 5.1 3.4 7 10.5-5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m35.4 329 5.3-3.4-4.2-16.2-5.6 2 4.5 17.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#66ff90" d="m260.4 272 31.5-7-1 8.7-31.5 7.4 1-9.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b0ff"
              d="m186.3 341.2-3.4 7.3-6.6 18.9 3.2-6.6 6.8-19.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m314.3 211.1 30.7-8.9-4.3-6.6-30.5 8.8 4.1 6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6aff8d"
              d="m98.4 277.7 27.8-5.5-.6-10.7-27.9 4.5.7 11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m295.3 191.5 29.8-8.2-5.7-1.4-29.5 8 5.4 1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#49ffad"
              d="m77.1 295.5 23.1-6.1-1.8-11.7-23.3 5 2 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f4f802"
              d="m239.6 201.9 32.5-6.2 4.7-3.4-32.5 6.1-4.7 3.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#8d0000"
              d="m65.7 41 1.8 15.1L82.8 54l-1.7-15.2L65.7 41z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0040ff"
              d="m148.3 398.5-5.8-3.5-9.5 8.4 5.1 4.2 10.2-9.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1fffd7"
              d="m49.4 320.7 13-6.1-3.4-13.5-13.4 4.7 3.8 14.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m40.7 325.6 8.7-4.9-3.8-14.9-9.1 3.6 4.2 16.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m310.2 204.4 30.5-8.8-4.8-5.4-30.3 8.7 4.6 5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b4ff43"
              d="m158.9 237.4 33.6-4.5 2.2-8.1-33.5 3.9-2.3 8.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m300.6 194.5 30-8.4-5.5-2.8-29.8 8.2 5.3 3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#007cff"
              d="m176.3 367.4-5 3.7-8 15.5 4.6-3 8.4-16.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m305.6 198.9 30.3-8.7-5.3-4.1-30 8.4 5 4.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m199 314.5 26.1-9-3.7 7-26.3 9.5 3.9-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0054ff" d="M163.3 386.6h-6l-9 11.9 5.4.7 9.6-12.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d60000"
              d="m39.8 73.2 3.1 16.2L56 78.9l-3-16.3-13.2 10.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m134.4 366.8 11.4-11.5-6.8 3.7-12.1 11.9 7.5-4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m197.7 217.5 34-4.8 3.6-6-33.8 4.6-3.8 6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9c00"
              d="m18 156.9 3.6 14.9 7.2-19.3-3.3-15.5-7.5 19.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#30ffc7"
              d="m27.6 311.5 3.3-.1-3-18.2-3.5-1.3 3.2 19.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#aaff4d"
              d="m289.7 237.9 31.8-6.7 1.5 8.8-31.7 6.9-1.6-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#0050ff" d="m128.8 396.8-2-8.7-9 4.8 1.3 9 9.7-5.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00e4f8"
              d="m173.6 332.1 21.5-10.1-4.6 6.2-22 10.6 5.1-6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c0ff"
              d="m152.1 349.8 16.4-11-5.7 5.1-17 11.4 6.3-5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m244.4 198.4 32.4-6.1 5.1-2-32.4 6.1-5.1 2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a0ff56"
              d="m126 250.9 31.5-4.2 1.4-9.3-31.4 3.5-1.5 10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m229.9 288.5 29.5-7.4-1.9 8.4-29.6 8 2-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0080ff"
              d="m128.3 378 6.1-11.2-7.5 4.1-6.8 11.4 8.2-4.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#46ffb1"
              d="m59 301.1 18.1-5.6-2-12.8-18.4 4.4 2.3 14z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m194.7 245.7.3 13.5-.1 25.4-.3-13 .1-25.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="M260.5 262.7 292 256l-.1 9-31.5 7 .1-9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m126.8 388.1 1.5-10.2-8.2 4.4-2.3 10.6 9-4.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5dff9a"
              d="m22.1 288.5 2.3 3.4-1.4-19.7-2.4-4.8 1.5 21.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6000"
              d="m167.2 113.7 1.6 15.1 9.6 23.8-1.6-15-9.6-23.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m16.5 193.2 3 12.9 4.9-20.6-2.8-13.7-5.1 21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#87ff70"
              d="m97.7 266 27.9-4.5.4-10.6-27.9 3.6-.4 11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#6aff8d"
              d="m75.1 282.7 23.3-5-.7-11.7-23.4 3.9.8 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="m287.3 229.3 31.9-6.6 2.3 8.5-31.8 6.7-2.4-8.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#36ffc1" d="m30.9 311.4 5.6-2-2.7-16.8-5.9.6 3 18.2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#caff2c"
              d="m161.2 228.7 33.5-3.9 3-7.3-33.4 3.5-3.1 7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e7ff0f"
              d="m201.5 211.3 33.8-4.6 4.3-4.8-33.7 4.4-4.4 5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#90ff66" d="m18.6 260.4 2 7 .5-20.7-2-8.2-.5 21.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#caff2c"
              d="m16.8 228.3 2.3 10.2 2.6-21.1-2.2-11.3-2.7 22.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#40ffb7"
              d="m45.6 305.8 13.4-4.7-2.3-14-13.6 3.4 2.5 15.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m249.5 196.4 32.4-6.1 5.3-.6-32.3 6.1-5.4.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0054ff"
              d="m142.5 395-4.9-6.1-8.8 7.9 4.2 6.6 9.5-8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#33ffc4" d="m202 305.8 25.9-8.3-2.8 8-26.1 9 3-8.7z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m36.5 309.4 9.1-3.6-2.5-15.3-9.3 2.2 2.7 16.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00acff"
              d="m141.2 360.7 10.8-10.9-6.2 5.5-11.4 11.5 6.8-6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="maroon"
              d="M81.1 38.8 82.8 54l15.8 2.3-1.8-15.2-15.7-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m185.8 178.1 1.5 15 4.9 26.2-1.5-14.8-4.9-26.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="m284.2 221.2 31.9-6.5 3.1 8-31.9 6.6-3.1-8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#94ff63"
              d="m259.7 253.2 31.6-6.3.7 9.1-31.5 6.7-.8-9.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m177.8 323.9 21.2-9.4-3.9 7.5-21.5 10.1 4.2-8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m157.5 342.4 16.1-10.3-5.1 6.7-16.5 11 5.5-7.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#66ff90" d="m230.9 279 29.5-7-1 9.1-29.5 7.5 1-9.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m254.9 195.8 32.3-6.1 5.4.8-32.3 6.1-5.4-.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b7ff40"
              d="m127.5 240.9 31.4-3.5 2.3-8.7-31.3 2.9-2.4 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m194.9 284.6-1.5 11.2-2.4 23.5 1.4-10.5 2.5-24.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2500"
              d="m31.4 103.6 3.6 16.3L46.3 106l-3.4-16.6-11.5 14.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#66ff90"
              d="m56.7 287.1 18.4-4.4-.8-12.8-18.5 3.1.9 14.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m135.8 371.3 5.4-10.6-6.8 6.1-6.1 11.1 7.5-6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0068ff"
              d="m157.3 386.6-6.4-2.8-8.4 11.2 5.8 3.5 9-11.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e1ff16"
              d="m280.3 214 32-6.4 3.8 7.1-31.9 6.5-3.9-7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m205.9 206.3 33.7-4.4 4.8-3.5-33.6 4.3-4.9 3.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#006cff"
              d="m137.6 388.9-2.6-8.1-8.2 7.3 2 8.7 8.8-7.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2900"
              d="m155.7 92.2 1.6 15.2 11.5 21.4-1.6-15.1-11.5-21.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#60ff97"
              d="m24.4 291.9 3.5 1.3-1.3-18.3-3.6-2.7 1.4 19.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m260.3 196.7 32.3-6.2 5.4 2.4-32.3 6.1-5.4-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m164.3 221 33.4-3.5 3.8-6.2-33.2 3.1-4 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a4ff53"
              d="m98.1 254.5 27.9-3.6 1.5-10-27.8 2.6-1.6 11z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0080ff"
              d="m135 380.9.8-9.6-7.5 6.7-1.5 10.1 8.2-7.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#87ff70"
              d="m74.3 269.9 23.4-3.9.4-11.5-23.4 2.8-.4 12.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#eeff09"
              d="m275.9 207.8 32-6.3 4.4 6.1-32 6.4-4.4-6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m265.7 199 32.3-6.2 5.1 3.7-32.1 6.2-5.3-3.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ad0000"
              d="m53 62.6 3 16.3 14.4-6.3-2.9-16.5L53 62.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m271 202.7 32.1-6.2 4.8 5-32 6.3-4.9-5.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m191 319.3-3.6 8.2-4.5 21 3.4-7.3 4.7-21.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#aaff4d"
              d="m258 243.8 31.7-5.9 1.6 9-31.6 6.3-1.7-9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#4dffaa"
              d="m204.1 296.2 25.8-7.7-2 9-25.9 8.3 2.1-9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#08f" d="m171.3 371.1-6.5.8-7.5 14.7h6l8-15.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="maroon"
              d="m96.9 41.1 1.7 15.2 15.8 6.8-1.8-15.3-15.7-6.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#66ff90"
              d="m43.1 290.5 13.6-3.4-.9-14.1-13.7 2 1 15.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m182.9 348.5-5.4 4.6-6.2 18 5-3.7 6.6-18.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m147.2 352.6 10.3-10.2-5.5 7.4-10.8 10.9 6-8.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#7dff7a" d="m231 269 29.5-6.3-.1 9.3-29.5 7 .1-10z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#60ff97"
              d="m27.9 293.2 5.9-.6-1.2-16.8-6-.9 1.3 18.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m210.8 202.7 33.5-4.3 5.2-2-33.4 4.2-5.3 2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#df0000"
              d="m142.5 73.8 1.6 15.1 13.2 18.5-1.6-15.2-13.2-18.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#63ff94"
              d="m33.8 292.6 9.3-2.1-1-15.5-9.5.8 1.2 16.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#90ff66"
              d="m20.6 267.4 2.4 4.8.4-19.4-2.3-6.1-.5 20.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#2cffca"
              d="m181 314.4 21-8.6-3 8.7-21.2 9.4 3.2-9.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="m129.9 231.6 31.3-2.9 3.1-7.7-31 2.3-3.4 8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6000"
              d="m25.5 137 3.3 15.5 9.3-16.6-3.1-16-9.5 17.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m162.1 333.4 15.7-9.5-4.2 8.2-16.1 10.3 4.6-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#920000"
              d="m112.6 47.8 1.8 15.3L129.7 74 128 58.8l-15.4-11z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#eeff09"
              d="m168.3 214.4 33.2-3.1 4.4-5-33 2.8-4.6 5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m255.5 234.8 31.8-5.5 2.4 8.6-31.7 5.9-2.5-9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#007cff"
              d="m150.9 383.8-5.5-5.3-7.8 10.4 4.9 6.1 8.4-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b20000"
              d="m128 58.8 1.7 15.2 14.4 14.9-1.6-15.1-14.5-15z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m192.2 219.3.4 14.1 2.4 25.8-.3-13.5-2.5-26.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#8aff6d"
              d="m55.8 273 18.5-3.1.4-12.6-18.5 1.8-.4 13.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m216.1 200.6 33.4-4.2 5.4-.6-33.2 4.2-5.6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="m99.7 243.5 27.8-2.6 2.4-9.3-27.6 1.8-2.6 10.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b4ff"
              d="m142.4 362.4 4.8-9.8-6 8.1-5.4 10.6 6.6-8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa300"
              d="M178.4 152.6 180 168l7.3 25.1-1.5-15.1-7.4-25.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c7ff30"
              d="m19.1 238.5 2 8.2 2.5-19.9-1.9-9.4-2.6 21.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a7ff50"
              d="m74.7 257.3 23.4-2.8 1.6-11-23.3 1.7-1.7 12.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa300"
              d="m21.6 171.8 2.8 13.7 7-18.5-2.6-14.5-7.2 19.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#63ff94"
              d="m205.2 285.9 25.7-6.9-1 9.6-25.8 7.6 1.1-10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="m230.1 259 29.6-5.8.8 9.5L231 269l-.9-10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m19.5 206.1 2.2 11.3 4.7-19.6-2-12.3-4.9 20.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d4ff23"
              d="m252.2 226.5 32-5.3 3.1 8.1-31.8 5.5-3.3-8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0090ff"
              d="m145.4 378.5-3.3-7.3-7.1 9.6 2.6 8.1 7.8-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a0ff"
              d="m142.1 371.2.2-8.8-6.5 8.9-.8 9.6 7.1-9.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ffde00" d="m221.7 200 33.2-4.2 5.4.9-33 4.2-5.6-.9z" />
          </g>
          <g clipPath="url(#a)">
            <path fill="#8dff6a" d="m23 272.2 3.6 2.7.5-18-3.7-4.1-.4 19.4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m133.3 223.2 31-2.2 4-6.6-30.8 1.7-4.2 7.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m172.9 209.1 33-2.8 4.9-3.6-32.7 2.6-5.2 3.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#8aff6d" d="m42.1 275 13.7-2 .4-13.9-13.7.7-.4 15.2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m152.2 342.8 9.9-9.4-4.6 9-10.3 10.2 5-9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0098ff"
              d="m164.8 371.9-6.8-1.8-7.1 13.7 6.4 2.8 7.5-14.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#46ffb1"
              d="m183.3 303.9 20.8-7.7-2.1 9.6-21 8.6 2.3-10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m248.1 219 32.2-5 3.9 7.2-32 5.3-4.1-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#920000"
              d="m67.5 56.1 2.9 16.5 15.1-2.1L82.8 54l-15.3 2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#df0000"
              d="m42.9 89.4 3.4 16.6 12.8-10.2L56 78.9 42.9 89.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffde00"
              d="m227.3 200.9 33-4.2 5.5 2.3-32.8 4.3-5.7-2.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#26ffd1"
              d="m165.7 323 15.3-8.6-3.2 9.5-15.7 9.5 3.6-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#83ff73"
              d="m195 259.2-1.5 12-.1 24.6 1.5-11.2.1-25.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m243.5 212.5 32.4-4.7 4.4 6.2-32.2 5-4.6-6.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m233 203.3 32.8-4.3 5.2 3.8-32.6 4.4-5.4-3.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#8dff6a" d="m26.6 274.9 6 .9.5-16.6-6-2.3-.5 18z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#8dff6a"
              d="m32.6 275.8 9.5-.8.4-15.2-9.4-.6-.5 16.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#adff49"
              d="m228.3 249 29.7-5.2 1.7 9.4-29.6 5.8-1.8-10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m238.4 207.2 32.6-4.5 4.9 5.1-32.4 4.7-5.1-5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m102.3 233.4 27.6-1.8 3.4-8.3-27.4 1-3.6 9.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="M205.2 275.1 231 269l-.1 10-25.7 6.9v-10.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#aaff4d"
              d="m56.2 259.1 18.5-1.8 1.7-12.1-18.4.7-1.8 13.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c4ff"
              d="m177.5 353.1-6.8 1.9-5.9 16.9 6.5-.8 6.2-18z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m178.1 205.3 32.7-2.6 5.3-2.1-32.4 2.4-5.6 2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m76.4 245.2 23.3-1.7 2.6-10.1-23.1.7-2.8 11.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="m147.8 351.6 4.4-8.8-5 9.8-4.9 9.8 5.5-10.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#46ffb1"
              d="m193.4 295.8-3.7 9.1-2.3 22.6 3.6-8.2 2.4-23.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m21.1 246.7 2.3 6.1 2.4-18.6-2.2-7.4-2.5 19.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6400"
              d="m168.8 128.8 1.8 15.7L180 168l-1.6-15.4-9.6-23.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m137.5 216.1 30.8-1.7 4.6-5.3-30.5 1.3-4.9 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00a8ff"
              d="m158 370.1-6.1-4.3-6.5 12.7 5.5 5.3 7.1-13.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0ff8e7"
              d="m187.4 327.5-5.7 5.6-4.2 20 5.4-4.6 4.5-21z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c4ff33"
              d="m225.6 239.5 29.9-4.7 2.5 9-29.7 5.2-2.7-9.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#63ff94"
              d="m184.4 292.7 20.8-6.8-1.1 10.3-20.8 7.7 1.1-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m187.3 193.1.5 14.7 4.8 25.5-.4-14-4.9-26.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3000"
              d="m35 119.9 3.1 16 11-13.4-2.8-16.5L35 119.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00c8ff"
              d="m148.1 359.5-.3-7.9-5.4 10.8-.3 8.8 6-11.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m183.7 203 32.4-2.4 5.6-.6-32.1 2.4-5.9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00b8ff"
              d="m151.9 365.8-3.8-6.3-6 11.7 3.3 7.3 6.5-12.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m156.1 331.4 9.5-8.4-3.5 10.4-9.9 9.4 3.9-11.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#adff49"
              d="m42.5 259.8 13.7-.7 1.8-13.2-13.6-.6-1.9 14.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#840000"
              d="m82.8 54 2.7 16.5 15.6 2.3-2.5-16.5L82.8 54z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#97ff60"
              d="m204.2 264.3 25.9-5.3.9 10-25.8 6.1-1-10.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#43ffb4"
              d="m168.1 311.5 15.1-7.6-2.2 10.5-15.4 8.6 2.5-11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m21.7 217.4 1.9 9.4 4.4-18.5-1.6-10.5-4.7 19.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m222 230.6 30.2-4.1 3.3 8.3-29.9 4.7-3.6-8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#eeff09"
              d="m105.9 224.3 27.4-1.1 4.2-7.1-27.1.4-4.5 7.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="m23.4 252.8 3.7 4.1 2.1-17.2-3.4-5.5-2.4 18.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m142.4 210.4 30.5-1.3 5.2-3.8-30.1 1-5.6 4.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="gold" d="m189.6 202.4 32.1-2.4 5.6.9-31.7 2.4-6-.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m28.8 152.5 2.6 14.5 8.9-15.9-2.2-15.2-9.3 16.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#caff2c"
              d="m58 245.9 18.4-.7 2.8-11.1-18.2-.5-3 12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#b4ff43" d="m33.1 259.2 9.4.6 1.9-14.5-9.3-2-2 15.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffae00"
              d="m24.4 185.5 2 12.3 6.7-17.6-1.7-13.2-7 18.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m79.2 234.1 23.1-.7 3.6-9.1-22.8-.2-3.9 10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2d00"
              d="m157.3 107.4 1.9 15.9 11.4 21.2-1.8-15.7-11.5-21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ebff0c"
              d="m217.7 222.6 30.4-3.6 4.1 7.5-30.2 4.1-4.3-8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf"
              d="m170.7 355-7.3-.8-5.4 15.9 6.8 1.8 5.9-16.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b00"
              d="m56 78.9 3.1 16.9 14.1-6.1-2.8-17.1L56 78.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b7ff40"
              d="m27.1 256.9 6 2.3 2-15.9-5.9-3.6-2.1 17.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="gold"
              d="m195.6 203.3 31.7-2.4 5.7 2.4-31.4 2.6-6-2.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#7dff7a"
              d="m184.4 280.9 20.8-5.8v10.8l-20.8 6.8v-11.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b1ff46"
              d="m202.2 253.5 26.1-4.5 1.8 10-25.9 5.3-2-10.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m152.1 339.2 4-7.8-3.9 11.4-4.4 8.8 4.3-12.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m212.8 215.7 30.7-3.2 4.6 6.5-30.4 3.6-4.9-6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m201.6 205.9 31.4-2.6 5.4 3.9-31.1 2.9-5.7-4.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#890000"
              d="m98.6 56.3 2.5 16.6 15.6 6.6-2.3-16.4-15.8-6.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m207.3 210.1 31.1-2.9 5.1 5.3-30.7 3.2-5.5-5.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m192.6 233.4-1.5 12.8 2.4 25 1.5-12-2.4-25.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="gold" d="m148 206.3 30.1-1 5.6-2.3-29.7.8-6 2.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m110.4 216.5 27.1-.4 4.9-5.7-26.6-.1-5.4 6.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#60ff97"
              d="m169.3 299.2 15.1-6.5-1.2 11.2-15.1 7.6 1.2-12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#3cffba"
              d="m158.7 318.8 9.4-7.3-2.5 11.5-9.5 8.4 2.6-12.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e40000"
              d="m144.1 88.9 2.1 16.2 13 18.2-1.9-15.9-13.2-18.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#00d8ff"
              d="M163.4 354.2 157 351l-5.1 14.8 6.1 4.3 5.4-15.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#16ffe1"
              d="m181.8 333.1-7.1 3-4 18.9 6.8-1.9 4.3-20z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#0cf4eb"
              d="m152.7 345.9-.6-6.7-4.3 12.4.3 7.9 4.6-13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="m44.4 245.3 13.6.6 3-12.3-13.3-1.7-3.3 13.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9b0000"
              d="m114.4 63.1 2.3 16.4 15.2 10.9-2.2-16.4-15.3-10.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f4f802"
              d="m23.6 226.8 2.2 7.4 4.1-17.2-1.9-8.7-4.4 18.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c7ff30"
              d="m199.2 243.2 26.4-3.7 2.7 9.5-26.1 4.5-3-10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m180 168 .7 15.1 7.1 24.7-.5-14.7L180 168z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b00"
              d="m129.7 74 2.2 16.4 14.3 14.7-2.1-16.2L129.7 74z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#02e8f4"
              d="m157 351-4.3-5.1-4.6 13.6 3.8 6.3L157 351z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m193.5 271.2-3.8 10.1v23.6l3.7-9.1.1-24.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m83.1 224.1 22.8.2 4.5-7.8-22.4-.9-4.9 8.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9aff5d"
              d="m183.3 269.1 20.9-4.8 1 10.8-20.8 5.8-1.1-11.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#49ffad"
              d="m189.7 304.9-5.8 6.7-2.1 21.5 5.6-5.6 2.3-22.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ffd000" d="m154 203.8 29.7-.8 5.9-.6-29.3.7-6.3.7z" />
          </g>
          <g clipPath="url(#a)">
            <path fill="#e7ff0f" d="m61 233.6 18.2.5 3.9-10-17.8-1.5-4.3 11z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f10800"
              d="m46.3 106 2.8 16.5 12.5-9.8-2.5-16.9L46.3 106z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#dbff1c"
              d="m35.1 243.3 9.3 2 3.3-13.5-9-3.2-3.6 14.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m195.4 233.6 26.6-3 3.6 8.9-26.4 3.7-3.8-9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="gold" d="m115.8 210.3 26.6.1 5.6-4.1-26.2-.5-6 4.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ebff0c"
              d="m25.8 234.2 3.4 5.5 3.9-16-3.2-6.7-4.1 17.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9f0000"
              d="m70.4 72.6 2.8 17 14.9-1.9-2.6-17.2-15.1 2.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#36ffc1"
              d="m155 325.3 3.7-6.5-2.6 12.6-4 7.8 2.9-13.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m26.4 197.8 1.6 10.5 6.3-16.5-1.2-11.6-6.7 17.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#fc0" d="m160.3 203.1 29.3-.7 6 .9-28.8.9-6.5-1.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m169.3 286.3 15.1-5.4v11.8l-15.1 6.5v-12.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e1ff16"
              d="m29.2 239.7 5.9 3.6 3.6-14.7-5.6-4.9-3.9 16z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#f1fc06" d="m190.7 225 27-2.4 4.3 8-26.6 3-4.7-8.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5dff9a"
              d="m160.1 305.2 9.2-6-1.2 12.3-9.4 7.3 1.4-13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3b00"
              d="m38.1 135.9 2.2 15.2 10.6-12.8-1.8-15.8-11 13.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#1cffdb"
              d="m174.7 336.1-7.6.4-3.7 17.7 7.3.8 4-18.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b7ff40"
              d="m181.1 257.3 21.1-3.8 2 10.8-20.9 4.8-2.2-11.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fc0"
              d="m166.8 204.2 28.8-.9 6 2.6-28.4 1.1-6.4-2.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7a00"
              d="m31.4 167 1.7 13.2 8.5-15.1-1.3-14-8.9 15.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffea00"
              d="m185.4 217.5 27.4-1.8 4.9 6.9-27 2.4-5.3-7.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m88 215.6 22.4.9 5.4-6.2-21.9-1.6-5.9 6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd000"
              d="m173.2 207 28.4-1.1 5.7 4.2-27.8 1.4-6.3-4.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f4f802"
              d="m47.7 231.9 13.3 1.7 4.3-11-13-2.8-4.6 12.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m179.5 211.5 27.8-1.4 5.5 5.6-27.4 1.8-5.9-6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc800"
              d="m121.8 205.8 26.2.5 6-2.5-25.7-.7-6.5 2.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m170.6 144.5.8 15.7 9.3 22.9-.7-15.1-9.4-23.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m187.8 207.8-1.3 13.6 4.6 24.8 1.5-12.8-4.8-25.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#30ffc7"
              d="m155.9 330.8-.9-5.5-2.9 13.9.6 6.7 3.2-15.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe600"
              d="m65.3 222.6 17.8 1.5 4.9-8.5-17.3-2.3-5.4 9.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#23ffd4"
              d="m167.1 336.5-6.7-1.9L157 351l6.4 3.2 3.7-17.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#29ffce"
              d="m160.4 334.6-4.5-3.8-3.2 15.1 4.3 5.1 3.4-16.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d1ff26"
              d="m177.8 246.1 21.4-2.9 3 10.3-21.1 3.8-3.3-11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#9dff5a"
              d="m168 273.3 15.3-4.2 1.1 11.8-15.1 5.4-1.3-13z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc400"
              d="m28 208.3 1.9 8.7 5.9-15.5-1.5-9.7-6.3 16.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#4dffaa"
              d="m183.9 311.6-7.2 4.2-2 20.3 7-3 2.2-21.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#920000"
              d="m85.5 70.5 2.6 17.2 15.2 2.3-2.2-17.2-15.6-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m128.3 203.1 25.7.7 6.3-.7-25.1-.8-6.9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m38.7 228.6 9 3.3 4.6-12.1-8.6-4.4-5 13.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#5aff9d"
              d="m156.4 310.5 3.7-5.3-1.4 13.6-3.7 6.5 1.4-14.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c80000"
              d="m59.1 95.8 2.5 16.9 13.6-6-2-17-14.1 6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#beff39"
              d="m191.1 246.2-3.6 11 2.2 24.1 3.8-10.1-2.4-25z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#80ff77" d="m160 291.1 9.3-4.8v12.9l-9.2 6-.1-14.1z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc800"
              d="m93.9 208.7 21.9 1.6 6-4.5-21.4-2-6.5 4.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m189.7 281.3-5.7 7.8-.1 22.5 5.8-6.7v-23.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e7ff0f"
              d="m173.5 235.6 21.9-2 3.9 9.6-21.5 2.9-4.3-10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd300"
              d="m29.9 217 3.2 6.7 5.5-14.3-2.8-7.9-5.9 15.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3400"
              d="m159.2 123.3 1 16.2 11.2 20.7-.8-15.7-11.4-21.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffde00"
              d="m33.1 223.7 5.6 4.9 5-13.2-5.1-6-5.5 14.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m135.2 202.3 25.1.8 6.5 1.1-24.5-.8-7.1-1.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="gold"
              d="m52.3 219.8 13 2.8 5.4-9.3-12.5-3.8-5.9 10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fc0"
              d="m70.7 213.3 17.3 2.3 5.9-6.9-16.9-3-6.3 7.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8600"
              d="m33.1 180.2 1.2 11.6 8-14.2-.7-12.5-8.5 15.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#baff3c"
              d="m165.5 260.4 15.6-3.1 2.2 11.8-15.3 4.2-2.5-12.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#960000"
              d="m101.1 72.9 2.2 17.1 15.3 6.6-1.9-17.1-15.6-6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m168.4 226.2 22.3-1.2 4.7 8.6-21.9 2-5.1-9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#56ffa0"
              d="m157.5 314.5-1.1-4-1.4 14.8.9 5.5 1.6-16.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#4dffaa"
              d="m176.7 315.8-7.7 1.7-1.9 19 7.6-.4 2-20.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1300"
              d="m49.1 122.5 1.8 15.8 12-9.4-1.3-16.2-12.5 9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffbd00"
              d="m142.3 203.4 24.5.8 6.4 2.8-23.9-.5-7-3.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffae00"
              d="m180.7 183.1-1.2 14.4 7 23.9 1.3-13.6-7.1-24.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f10800"
              d="m146.2 105.1 1.3 16.5 12.7 17.9-1-16.2-13-18.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m100.4 203.7 21.4 2.1 6.5-2.7-20.7-2.3-7.2 2.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffdb00"
              d="m162.5 218 22.9-.5 5.3 7.5-22.3 1.2-5.9-8.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4a00"
              d="m40.3 151.1 1.3 14L51.7 153l-.8-14.7-10.6 12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m149.3 206.5 23.9.5 6.3 4.5-23.4-.1-6.8-4.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#fc0" d="m156.1 211.4 23.4.1 5.9 6-22.9.5-6.4-6.6z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a40000"
              d="m116.7 79.5 1.9 17.1 14.9 10.6-1.6-16.8-15.2-10.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a0ff56"
              d="m158.6 276.8 9.4-3.5 1.3 13-9.3 4.8-1.4-14.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c40000"
              d="m131.9 90.4 1.6 16.8 14 14.4-1.3-16.5-14.3-14.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#53ffa4"
              d="m162.1 317-4.6-2.5-1.6 16.3 4.5 3.8 1.7-17.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m156.3 295 3.7-3.9.1 14.1-3.7 5.3-.1-15.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#50ffa7"
              d="m169 317.5-6.9-.5-1.7 17.6 6.7 1.9 1.9-19z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m161.9 248.1 15.9-2 3.3 11.2-15.6 3.1-3.6-12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc800"
              d="m43.7 215.4 8.6 4.4 5.9-10.3-8-5.3-6.5 11.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ad0000"
              d="m73.2 89.7 2 17 14.4-1.8L88 87.7l-14.8 2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m34.3 191.8 1.5 9.7 7.5-13.3-1-10.6-8 14.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb600"
              d="m77.1 205.7 16.8 3 6.5-4.9-16.1-3.6-7.2 5.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#80ff77" d="m184 289.1-7.3 5.5v21.2l7.2-4.2.1-22.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffae00"
              d="m107.6 200.8 20.7 2.3 6.9-.8-20-2.4-7.6.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m58.2 209.5 12.5 3.8 6.3-7.6-11.8-4.5-7 8.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f8f500"
              d="m186.5 221.4-3.5 12 4.5 23.8 3.6-11-4.6-24.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb600"
              d="m38.6 209.4 5.1 6 6.5-11.2-4.7-7.1-6.9 12.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m35.8 201.5 2.8 7.9 6.9-12.3-2.2-8.9-7.5 13.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#baff3c"
              d="m187.5 257.2-5.7 9.1 2.2 22.8 5.7-7.8-2.2-24.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m157.2 236.5 16.3-.9 4.3 10.5-15.9 2-4.7-11.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c1ff36"
              d="m155.9 262.6 9.6-2.2 2.5 12.9-9.4 3.5-2.7-14.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m157.4 297.6-1.1-2.6.1 15.5 1.1 4-.1-16.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7300"
              d="m171.4 160.2-.9 15 9 22.3 1.2-14.3-9.3-23z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m115.2 199.9 20 2.4 7.1 1.1-19.4-2.2-7.7-1.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5d00"
              d="m41.6 165.1.7 12.5 9.6-11.5-.2-13.1-10.1 12.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a4ff53"
              d="m154.8 279.2 3.8-2.4 1.4 14.3-3.7 3.9-1.5-15.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#da0000"
              d="m61.6 112.7 1.3 16.2 13.1-5.7-.8-16.5-13.6 6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="M151.6 226.2h16.8l5.1 9.4-16.3.9-5.6-10.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa300"
              d="m84.3 200.2 16.1 3.6 7.2-3-15.5-3.8-7.8 3.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#80ff77" d="m176.7 294.6-7.7 3.1v19.8l7.7-1.7v-21.2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a40000"
              d="m88 87.7 1.6 17.1 14.9 2.3-1.2-17.1L88 87.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffab00"
              d="m122.9 201.2 19.4 2.2 7 3.1-18.7-1.9-7.7-3.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ffa700" d="m50.1 204.1 8.1 5.4 7-8.3-7.4-6.1-7.7 9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#80ff77"
              d="m162.1 298.6-4.7-1 .1 16.9 4.6 2.5v-18.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2500"
              d="m50.9 138.3.8 14.7 11.4-9-.2-15.1-12 9.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#fc0" d="m145.1 217.2 17.4.8 5.9 8.2h-16.8l-6.5-9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffae00"
              d="m130.6 204.6 18.7 1.9 6.8 4.9-18-1.4-7.5-5.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#80ff77" d="m169 297.7-6.9.9V317l6.9.5v-19.8z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9f00"
              d="m65.2 201.2 11.9 4.5 7.2-5.5-11.2-5-7.9 6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ffbd00" d="m138.1 210 18 1.4 6.4 6.6-17.4-.8-7-7.2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e1ff16"
              d="m151.9 249 10-.9 3.6 12.3-9.6 2.2-4-13.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3f00"
              d="m160.2 139.5-.5 15.7 10.8 20 .9-15-11.2-20.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6f00"
              d="m42.3 177.6 1 10.6 8.9-10.6-.3-11.5-9.6 11.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb600"
              d="m179.5 197.5-3.2 13 6.7 22.9 3.5-12-7-23.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9800"
              d="m92.1 197 15.5 3.8 7.5-.9-14.7-3.9-8.3 1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ff9400" d="m45.5 197.1 4.6 7 7.7-9-4-7.9-8.3 9.9z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b7ff40"
              d="m181.8 266.3-7.1 6.7 2 21.6 7.3-5.5-2.2-22.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a40000"
              d="m103.3 90 1.2 17.1 14.8 6.4-.7-16.9-15.3-6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#a7ff50"
              d="m155.7 280.4-.9-1.2 1.5 15.8 1.1 2.6-1.7-17.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c7ff30"
              d="m151.8 263.7 4.1-1.1 2.7 14.2-3.8 2.4-3-15.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8200"
              d="m43.3 188.2 2.2 8.9 8.3-9.9-1.6-9.6-8.9 10.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f1fc06"
              d="m183 233.4-5.5 10.2 4.3 22.6 5.7-9-4.5-23.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fbf100"
              d="m146.7 236.3 10.5.2 4.7 11.6-10 .9-5.2-12.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1300"
              d="m147.5 121.6-.2 16.3 12.4 17.3.5-15.7-12.7-17.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c40000"
              d="m75.2 106.7.8 16.5 13.9-1.7-.3-16.7-14.4 1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b60000"
              d="m118.6 96.6.7 16.9 14.4 10.4-.2-16.7-14.9-10.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="m100.4 196 14.7 3.9 7.8 1.3-14-3.8-8.5-1.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8d00"
              d="m73.1 195.2 11.2 5 7.8-3.2-10.4-5.4-8.6 3.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8d00"
              d="m57.8 195.1 7.4 6.1 7.9-6-6.7-6.7-8.6 6.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d10000"
              d="m133.5 107.2.2 16.7 13.6 14 .2-16.3-14-14.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3800"
              d="m51.7 153 .2 13.1 10.8-8.4.4-13.7-11.4 9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#adff49"
              d="m160.3 279.9-4.6.5 1.7 17.2 4.7 1-1.8-18.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b4ff43"
              d="m174.7 273-7.6 4.5 1.9 20.2 7.7-3.1-2-21.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd300"
              d="m140.5 224.9 11.1 1.3 5.6 10.3-10.5-.2-6.2-11.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f10800"
              d="m62.9 128.9.2 15.1 12.5-5.3.4-15.5-13.1 5.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="m108.9 197.4 14 3.8 7.7 3.4-13.2-3.5-8.5-3.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b1ff46"
              d="m167.1 277.6-6.8 2.3 1.8 18.7 6.9-.9-1.9-20.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ebff0c"
              d="m147.4 248.7 4.5.3 4 13.6-4.1 1.1-4.4-15z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7e00"
              d="m170.5 175.2-2.8 13.9 8.6 21.4 3.2-13-9-22.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb900"
              d="m133.4 215.1 11.7 2.1 6.5 9-11.1-1.3-7.1-9.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9c00"
              d="m117.4 201.1 13.2 3.5 7.5 5.4-12.5-2.9-8.2-6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ceff29" d="m152.4 263.4-.6.3 3 15.5.9 1.2-3.3-17z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m125.6 207.1 12.5 2.9 7 7.2-11.7-2.1-7.8-8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#f70" d="m53.8 187.2 4 7.9 8.6-6.6-3.2-8.5-9.4 7.2z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8200"
              d="m81.7 191.6 10.4 5.4 8.3-1-9.6-5.5-9.1 1.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4a00"
              d="m51.9 166.1.3 11.5 10.1-7.8.4-12.1-10.8 8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b60000"
              d="m89.6 104.8.3 16.7 14.3 2.2.3-16.6-14.9-2.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ebff0c"
              d="m177.5 243.6-6.9 8.1 4.1 21.3 7.1-6.7-4.3-22.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6000"
              d="m52.2 177.6 1.6 9.6 9.4-7.2-.9-10.2-10.1 7.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#f70" d="m66.4 188.5 6.7 6.7 8.6-3.6-5.9-7.1-9.4 4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m176.3 210.5-5.2 11.3 6.4 21.8 5.5-10.2-6.7-22.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m141.7 234.8 5 1.5 5.2 12.7-4.5-.3-5.7-13.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d7ff1f"
              d="m156.7 261.4-4.3 2 3.3 17 4.6-.5-3.6-18.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4a00"
              d="m159.7 155.2-2.5 14.7 10.5 19.2 2.8-13.9-10.8-20z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7a00"
              d="m90.8 190.5 9.6 5.5 8.5 1.4-8.8-5.3-9.3-1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1a00"
              d="m63.1 144-.4 13.7 11.7-5 1.2-14-12.5 5.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#da0000"
              d="m76 123.2-.4 15.5 13.2-1.7 1.1-15.5-13.9 1.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#f4f802" d="m147.6 247-.2 1.7 4.4 15 .6-.3-4.8-16.4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e4ff13"
              d="m170.6 251.7-7.4 5.9 3.8 20 7.7-4.6-4.1-21.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#b00"
              d="m104.5 107.1-.3 16.6 14.2 6.1.9-16.3-14.8-6.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc100"
              d="m134.8 222.3 5.7 2.6 6.2 11.4-5-1.5-6.9-12.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#deff19"
              d="m163.2 257.6-6.5 3.8 3.6 18.5 6.7-2.3-3.8-20z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6000"
              d="m63.2 180 3.2 8.5 9.4-4-2.4-8.8-10.2 4.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ff7e00" d="m100.1 192.1 8.8 5.3 8.5 3.7-8-5-9.3-4z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m75.8 184.5 5.9 7.1 9.1-1.1-5.1-7.1-9.9 1.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1e00"
              d="m147.3 137.9-2 15.4 11.9 16.6 2.5-14.7-12.4-17.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa700"
              d="m127 211.4 6.4 3.7 7.1 9.8-5.7-2.6-7.8-10.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#c80000"
              d="m119.3 113.5-.9 16.3 13.9 10 1.4-15.9-14.4-10.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path fill="#ff8600" d="m109.4 196.1 8 5 8.2 6-7.1-4.5-9.1-6.5z" />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3000"
              d="m62.7 157.7-.4 12.1 11-4.7 1.1-12.4-11.7 5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8900"
              d="m167.7 189.1-4.8 12.4 8.2 20.3 5.2-11.3-8.6-21.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="m118.5 202.6 7.1 4.5 7.8 8-6.4-3.7-8.5-8.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e40000"
              d="m133.7 123.9-1.4 15.9 13 13.5 2-15.4-13.6-14z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc800"
              d="m171.1 221.8-6.6 9.3 6.1 20.6 6.9-8.1-6.4-21.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4a00"
              d="m62.3 169.8.9 10.2 10.2-4.3-.1-10.6-11 4.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd300"
              d="m141.4 231.8.3 3 5.7 13.9.2-1.7-6.2-15.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#feed00"
              d="m151.4 243.7-3.8 3.3 4.8 16.4 4.3-2-5.3-17.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#cd0000"
              d="M89.9 121.5 88.8 137l13.6 2.2 1.8-15.5-14.3-2.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6400"
              d="m85.7 183.4 5.1 7.1 9.3 1.6-4.2-7.1-10.2-1.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f10800"
              d="m75.6 138.7-1.2 14 12.5-1.5 1.9-14.2-13.2 1.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffd300"
              d="m164.5 231.1-6.9 7.3 5.6 19.2 7.4-5.9-6.1-20.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5200"
              d="m73.4 175.7 2.4 8.8 9.9-1.1-1.5-9-10.8 1.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffe200"
              d="m157.6 238.4-6.2 5.3 5.3 17.8 6.5-3.9-5.6-19.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb200"
              d="m133.9 218.1.9 4.2 6.9 12.5-.3-3-7.5-13.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff5900"
              d="m157.2 169.9-4.3 13.2 10 18.4 4.8-12.4-10.5-19.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6400"
              d="m95.9 185 4.2 7.1 9.3 4-3.3-6.6-10.2-4.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f20"
              d="m74.4 152.7-1.1 12.4 11.7-1.4 1.9-12.5-12.5 1.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffc400"
              d="m144.7 227.1-3.3 4.7 6.2 15.2 3.8-3.3-6.7-16.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3800"
              d="m73.3 165.1.1 10.6 10.8-1.3.8-10.7-11.7 1.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="m162.9 201.5-6.2 10.5 7.8 19.1 6.6-9.3-8.2-20.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#d10000"
              d="m104.2 123.7-1.8 15.5L116 145l2.4-15.2-14.2-6.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9400"
              d="m125.4 206.2 1.6 5.2 7.8 10.9-.9-4.2-8.5-11.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6c00"
              d="m106.1 189.5 3.3 6.6 9.1 6.5-2.5-6-9.9-7.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7e00"
              d="m116 196.6 2.5 6 8.5 8.8-1.6-5.2-9.4-9.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3000"
              d="m145.3 153.3-3.7 14 11.3 15.8 4.3-13.2-11.9-16.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4a00"
              d="m84.2 174.4 1.5 9 10.2 1.6-.6-8.8-11.1-1.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#e80000"
              d="m88.8 137-1.9 14.2 12.8 2 2.7-14-13.6-2.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#df0000"
              d="m118.4 129.8-2.4 15.3 13.2 9.4 3.1-14.7-13.9-10z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffb200"
              d="m150.3 220.5-5.6 6.6 6.8 16.6 6.1-5.3-7.3-17.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fa0f00"
              d="m132.3 139.8-3.1 14.7 12.4 12.8 3.7-14.1-13-13.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ffa300"
              d="m156.8 212-6.5 8.5 7.3 17.9 7-7.3-7.8-19.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff9f00"
              d="m136.5 212.1-2.6 6 7.5 13.7 3.3-4.7-8.2-15z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6800"
              d="m152.9 183.1-5.5 11.6 9.3 17.3 6.2-10.5-10-18.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3000"
              d="m85 163.7-.8 10.7 11.1 1.8 1.7-10.6-12-1.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4a00"
              d="m95.3 176.2.6 8.8 10.2 4.5.3-8.4-11.1-4.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1a00"
              d="M86.9 151.2 85 163.7l12 1.9 2.7-12.4-12.8-2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7e00"
              d="m127.3 199.3-1.9 6.9 8.5 11.9 2.7-6-9.3-12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ed0400"
              d="m102.4 139.2-2.7 14 12.8 5.6L116 145l-13.6-5.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f50"
              d="m106.4 181.1-.3 8.4 9.9 7.1 1.1-7.8-10.7-7.7z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff8d00"
              d="m141.5 204.4-5 7.7 8.2 15 5.6-6.6-8.8-16.1z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6800"
              d="m117.1 188.8-1.1 7.8 9.4 9.6 1.9-6.9-10.2-10.5z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff7a00"
              d="m147.4 194.7-5.9 9.7 8.8 16.1 6.5-8.5-9.4-17.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4300"
              d="m141.6 167.3-4.9 12.5 10.7 14.9 5.5-11.6-11.3-15.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3400"
              d="m97 165.6-1.7 10.6 11.1 4.9 2.5-10.3-11.9-5.2z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#fa0f00"
              d="m116 145-3.5 13.8 12.5 8.9 4.2-13.2L116 145z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff1a00"
              d="M99.7 153.2 97 165.6l11.9 5.2 3.6-12-12.8-5.6z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f20"
              d="m129.2 154.5-4.2 13.2 11.7 12.1 4.9-12.5-12.4-12.8z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff6800"
              d="m131.5 190.5-4.2 8.8 9.2 12.8 5-7.7-10-13.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#f50"
              d="m136.7 179.8-5.2 10.7 10 13.9 5.9-9.7-10.7-14.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3b00"
              d="m108.9 170.8-2.5 10.3 10.7 7.7 3.4-9.6-11.6-8.4z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff4e00"
              d="m120.5 179.2-3.4 9.6 10.2 10.5 4.2-8.8-11-11.3z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff2500"
              d="m112.5 158.8-3.6 12 11.6 8.4 4.5-11.5-12.5-8.9z"
            />
          </g>
          <g clipPath="url(#a)">
            <path
              fill="#ff3800"
              d="m124.9 167.7-4.4 11.5 11 11.3 5.2-10.7-11.8-12.1z"
            />
          </g>
        </g>
      </g>
    </g>
  ),
});

export default av3CRV;
